import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  Box,
  Divider,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Chip,
  Card,
  IconButton,
  Stack,
  RadioGroup,
  ClickAwayListener,
  Radio,
  CardContent,
  CardActions,
  CardHeader,
  Popover,
  Popper,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  RESET_PATIENT_STATE,
  START_CREATE_PATIENT,
  START_UPDATE_PATIENT,
  START_GET_SINGLE_PATIENT,
  START_PHARMACY_LIST,
  START_GET_PATIENT_LIST,
  START_DRUG_LIST,
} from "Actions/PatientAction";
import {
  START_GET_REPEAT_ORDER_LIST,
  START_ORDER_COUNT_TYPE,
} from "Actions/RepeatOrderAction";
import { START_GET_GROUP_LIST } from "Actions/GroupAction";
import { START_GET_PHARMACIES_LIST } from "Actions/PharmacyAction";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import useViewport from "Hooks/useViewport";
import { ReactComponent as ComplianceIcon } from "Assets/Icons/ComplianceIcon.svg";
import { ReactComponent as Delivery } from "Assets/Icons/Delivery.svg";
import { ReactComponent as CollectionIcon } from "Assets/Icons/CollectionMedical .svg";
import { ReactComponent as DeleteIconLined } from "Assets/Icons/DeleteIconLined.svg";
import { ReactComponent as Daily } from "Assets/Icons/DispenseDaily.svg";
import { ReactComponent as Weekly } from "Assets/Icons/DispenseWeekly.svg";
import { ReactComponent as TwiceWeek } from "Assets/Icons/DispenseTwiceWeek.svg";
import { ReactComponent as ThriceWeek } from "Assets/Icons/DispenseThriceWeek.svg";
import { ReactComponent as Fortnightly } from "Assets/Icons/DispenseFortnightly.svg";
import { ReactComponent as AddIcon } from "Assets/Icons/AddIcon.svg";
import { ReactComponent as CloseIcon } from "Assets/Icons/CloseIcon.svg";
import { ReactComponent as ThickCross } from "Assets/Icons/ThickCross.svg";
import { useFormik } from "formik";
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { connect, useSelector } from "react-redux";
import * as yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { statusMenuItems, patientTypeMenuItems } from "utils/data";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { getLocalStorage, setLocalStorage, isEmptyObject } from "utils/generalUtils";
import moment from "moment";
import { useXssGuard } from "Hooks/useXssGuard";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import GroupAutoComplete from "Components/Patients/GroupAutoComplete";
import CreateSurgeryDialog from "Components/Surgery/CreateSurgeryDialog";
import SurgryAutoComplete from "Components/Patients/SurgeryAutoComplete";
import PharmacyAutoComplete from "Components/Patients/PharmacyAutoComplete";
import DrugAutoComplete from "Components/Patients/DrugAutoComplete";
import AutoCompleteTextField from "Components/Common/AutoCompleteTextField";
import DrugsDialog from "Components/Patients/DrugsDialog";
import { START_GET_HOME_LIST } from "Actions/HomeAction";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { START_GET_COLLECTION_LIST } from "Actions/CollectionAction";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import SubscriptionWaringDailog from "Components/Common/Dialog/SubscriptionWaringDailog";
import { ChromePicker } from "react-color";
const AddPharmacyDialog = React.lazy(() =>
  import("../Pharmacy/AddPharmacyDialog")
);
const CreateGroupDialog = React.lazy(() =>
  import("../Groups/CreateGroupDialog")
);
const ConfirmationDialog = React.lazy(() =>
  import("Components/Common/Dialog/ConfirmationDialog")
);
const PatientNotesDialog = React.lazy(() => import("./PatientNotesDialog"));
const PatientCreateTag = React.lazy(() => import("./PatientCreateTag"));
const useStyle = makeStyles((theme) => ({
  rsRootTextField: {
    "& .MuiInputBase-input": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  rsPatientPaperGeneralInfo: {
    // padding: "17px 13px 25px",
    // padding: "17px 13px 5px",
    paddingTop: "0px",
    paddingBottom: "20px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    // marginBottom: "60px",
    marginBottom: "12px",
  },
  rsPatientPaperAddNote: {
    paddingTop: "0px",
    // paddingBottom: "15px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    overflow: "auto",
    // maxHeight: "calc(34vh - 100px)",
    maxHeight: "calc(28vh - 100px)",
    // minHeight: "176px",
    minHeight: "142px",
    backgroundColor: theme.palette.background.default,
    width: "100%",
    // marginRight: "10px",
    marginBottom: "1px",
    "&>div": {
      "&>h6": {
        fontSize: "10px !important",
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "50%",
    },
    [theme.breakpoints.down("480")]: {
      width: "100%",
    },
  },
  rsPatientPaperAddNoteDialog: {
    paddingTop: "0px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    overflow: "auto",
    maxHeight: "calc(26vh - 100px)",
    minHeight: "142px",
    backgroundColor: theme.palette.background.default,
    width: "100%",
    marginBottom: "1px",
    "&>div": {
      "&>h6": {
        fontSize: "10px !important",
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "100%",
      marginBottom: "10px",
    },
    [theme.breakpoints.down("480")]: {
      width: "100%",
    },
  },
  rsPatientPaperAddNoteSmall: {
    paddingTop: "0px",
    // paddingBottom: "15px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    overflow: "auto",
    // maxHeight: "calc(34vh - 100px)",
    maxHeight: "calc(45vh - 100px)",
    // minHeight: "176px",
    minHeight: "142px",
    backgroundColor: theme.palette.background.default,
    width: "100%",
    // marginRight: "10px",
    marginBottom: "1px",
    "&>div": {
      "&>h6": {
        fontSize: "10px !important",
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "50%",
    },
    [theme.breakpoints.down("480")]: {
      width: "100%",
    },
  },
  rsPatientMedicationBtn: {
    padding: "0px 0px 0px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: "none !important",
    marginBottom: "5px",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      paddingRight: 0,
    },
    "& .MuiInputAdornment-root ": {
      backgroundColor: theme.palette.background.red,
      padding: "19px 14px",
      borderRadius: "0px 5px 5px 0px",
      cursor: "pointer",
    },
  },
  rsPatientAddNoteBtn: {
    "&:disabled": {
      backgroundColor: "grey !important",
      border: "none  !important",
      // textTransform: "capitalize !important",
      padding: "8px 13px !important",
      [theme.breakpoints.down("800")]: {
        padding: "8px 5px !important",
      },
      "&>span": {
        "&>svg": {
          "&>path": {
            // fill: "#5A687290 !important",
            backgroundColor: "yellow",
            // stroke: "none !important",
          },
        },
      },
    },
    border: "1px solid #7bbd4b  !important",
    backgroundColor: "#7bbd4b  !important",
    color: "#fff !important",
    // fontSize: "16px !important",
    padding: "8px 8px !important",
    fontWeight: "500 !important",
    "&>span": {
      "&>svg": {
        // width: "30px !important",
        // height: "30px !important",
        "&>path": {
          fill: "#fff !important",
          // stroke: "#fff !important",
        },
      },
    },
    // fontSize: "14px !important",
    // fontWeight: "400 !important",
    borderRadius: "5px !important",
    height: "35px !important",
  },
  rsPatientCancelBtn: {
    marginRight: "30px !important",
    // fontSize: "14px !important",
    // fontWeight: "400 !important",
    borderRadius: "5px !important",
    // marginBottom: "50px !important",
    borderRadius: "5px !important",
    // height: "37px !important",
    // minWidth: "85px !important",
    height: "48px !important",
    minWidth: "120px !important",
  },
  rsPatientGridOne: {
    position: "sticky",
    // top: "-24px",
    top: "0px",
    background: "white",
    zIndex: "10",
    paddingTop: "17px",
    "&>div": {
      "&>button": {
        padding: "8px 13px !important",
        // textTransform: "uppercase !important",
        fontWeight: "600 !important",
      },
      "&>div": {
        "&>hr": {
          backgroundColor: theme.palette.background.grey,
        },
        "&>button": {
          padding: "8px 13px !important",
        },
        overflow: "hidden",
        [theme.breakpoints.down("800")]: {
          overflow: "unset",
        },
        "&>div": {
          "&>div": {
            "&>label": {
              // color: "red !important",
              // zIndex: "0",
              fontSize: "9px !important",
            },
            "&>div": {
              "&>div": {
                background: "white",
                zIndex: "2",
              },
            },
          },
          "&>label": {
            // color: "red !important",
            zIndex: "1",
          },
          // "&>div": {
          //     "&>div": {
          //       background: "blue",
          //     },
          //   },
        },
      },
      "&>h3": {
        // fontSize: "23px !important",
        fontSize: "19px !important",
        [theme.breakpoints.down("800")]: {
          fontSize: "18px !important",
        },
        fontWeight: "500 !important",
        fontFamily: "Poppins",
        marginBottom: "10px",
        color: "black !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
        // marginBottom: "20px",
      },
    },
  },
  rsPatientGridOneDialog: {
    position: "sticky",
    top: "0px",
    background: "white",
    zIndex: "10",
    "&>div": {
      alignItems: "center",
      "&>button": {
        padding: "8px 13px !important",
        // textTransform: "uppercase !important",
        fontWeight: "600 !important",
        marginTop: "15px !important",
      },
      "&>div": {
        "&>hr": {
          backgroundColor: theme.palette.background.grey,
        },
        "&>button": {
          padding: "8px 13px !important",
        },
        overflow: "hidden",
        [theme.breakpoints.down("800")]: {
          overflow: "unset",
        },
        "&>div": {
          "&>div": {
            "&>label": {
              fontSize: "9px !important",
            },
            "&>div": {
              "&>div": {
                background: "white",
                zIndex: "2",
              },
            },
          },
          "&>label": {
            zIndex: "1",
          },
        },
      },
      "&>h3": {
        fontSize: "19px !important",
        [theme.breakpoints.down("800")]: {
          fontSize: "18px !important",
        },
        fontWeight: "500 !important",
        fontFamily: "Poppins",
        marginBottom: "10px",
        marginTop: "15px",
        color: "black !important",
      },
      "&>hr": {
        backgroundColor: theme.palette.background.grey,
      },
    },
  },
  rsPatientBtn: {
    // fontSize: "14px !important",
    // fontWeight: "400 !important",
    borderRadius: "5px !important",
    height: "37px",
    width: "",
  },
  rsSubmittBtn: {
    borderRadius: "5px !important",
    height: "48px !important",
    width: "120px !important",
    // textTransform: "uppercase !important",
    fontWeight: "600 !important",
  },
  rsTagBtn: {
    borderRadius: "5px !important",
    height: "35px !important",
    minWidth: "95px !important",
    padding: "0px !important",
    // textTransform: "uppercase !important",
    fontWeight: "600 !important",
  },
  rsPatientBtnDialog: {
    // fontSize: "14px !important",
    // fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginBottom: "55px !important",
    marginLeft: "30px !important",
  },
  rsMedicationGrudCloseIcon: {
    // backgroundColor: theme.palette.background.red,
    // width: "49px",
    height: "39px",
    borderRadius: "5px",
    cursor: "pointer",
    "&>div": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      // "&>svg":{
      //   fill: "black"
      // }
      "&>p": {
        fontSize: "14px",
        textDecoration: "underline",
      },
    },
  },
  formLabel: {
    "& .MuiFormControlLabel-label": {
      whiteSpace: "nowrap",
      fontSize: "16px !important",
      fontFamily: "Poppins !important",
      color: "black !important",
      fontWeight: "500 !important",
    },
    // marginBottom: "10px !important",
    width: "225px !important",
    fontSize: "16px !important",
    fontFamily: "Poppins !important",
    color: "black !important",
    fontWeight: "500 !important",
  },
  installMentFormLabel: {
    "&>span": {
      padding: "0px 5px !important",
    },
  },
  managePageH: {
    maxHeight: "calc(92vh - 125px)",
    overflow: "auto",
    [theme.breakpoints.down("1100")]: {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("700")]: {
      maxHeight: "calc(100vh - 165px)",
      overflowY: "auto",
      overflowX: "hidden",
    },
  },
  managePageSmall: {
    maxHeight: "unset",
    overflowY: "auto",
    overflowX: "hidden",
  },
  managePageHDialog: {
    maxHeight: "calc(95vh - 112px)",
    // maxHeight: "calc(100vh - 70px)",
    // overflow: "auto",
    // maxHeight: "unset",
    overflow: "auto",
    [theme.breakpoints.down("700")]: {
      maxHeight: "calc(100% - 64px)",
      overflowY: "auto",
      overflowX: "hidden",
    },
  },
  tableBody: {
    display: "flex",
    flexDirection: "column",
    "&>div:nth-child(2)": {
      // marginLeft: "20px !important",
      marginLeft: "10px !important",
      "&>div": {
        // marginTop: "9px !important",
        [theme.breakpoints.down("500")]: {
          marginTop: "0px !important",
        },
      },
    },
    "&>td": {
      padding: "10px 20px !important",
      borderBottom: `none !important`,
    },
    [theme.breakpoints.down("500")]: {
      flexDirection: "column !important",
      "&>div:nth-child(2)": {
        marginLeft: "0px !important",
        marginBottom: "15px !important",
      },
    },
  },
  chipMain: {
    position: "relative",
    display: "grid  !important",
    justifyContent: "center",
    justifyItems: "center",
    marginLeft: "10px",
    marginTop: "10px",
    height: "85px !important",
    minWidth: "150px !important",
    borderRadius: "5px !important",
    padding: "8px 20px !important",
    fontSize: "13px !important",
    cursor: "pointer  !important",
    "& .MuiChip-icon": {
      margin: "0px !important",
    },
    "&>svg": {
      width: "20px",
      height: "20px",
    },
    "&>span": {
      margin: "0px  !important",
      padding: "0px  !important",

      "&>div": {
        "&>svg": {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "18px",
          height: "18px",
        },
      },
    },
    "&:hover": {
      background: `${theme.palette.primary.main}25 !important`,
      borderColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.primary.main} !important`,
      background: `${theme.palette.primary.main}10 !important`,
      "&>svg": {
        "&>path": {
          fill: ` ${theme.palette.primary.main} !important`,
        },
      },
    },
  },
  chipMainCollection: {
    position: "relative",
    display: "grid  !important",
    justifyContent: "center",
    justifyItems: "center",
    marginLeft: "10px",
    marginTop: "10px",
    height: "85px !important",
    minWidth: "150px !important",
    borderRadius: "5px !important",
    padding: "8px 20px !important",
    fontSize: "13px !important",
    cursor: "pointer  !important",
    "& .MuiChip-icon": {
      margin: "0px !important",
    },
    "&>svg": {
      width: "20px",
      height: "20px",
    },
    "&>span": {
      margin: "0px  !important",
      padding: "0px  !important",

      "&>div": {
        "&>svg": {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "18px",
          height: "18px",
        },
      },
    },
    "&:hover": {
      background: `${theme.palette.primary.main}25 !important`,
      borderColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.primary.main} !important`,
      background: `${theme.palette.primary.main}10 !important`,
      "&>svg": {
        "&>rect": {
          fill: ` ${theme.palette.primary.main} !important`,
        },
      },
    },
  },
  chips: {
    borderColor: `${theme.palette.secondary.main} !important`,
    color: `${theme.palette.secondary.main} !important`,
    background: `${theme.palette.secondary.main}10 !important`,
    "&>svg": {
      "&>path": {
        fill: `${theme.palette.secondary.main} !important`,
      },
    },
  },
  chipsFilled: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    background: `${theme.palette.primary.main}10 !important`,
    "&>svg": {
      "&>path": {
        fill: ` ${theme.palette.primary.main} !important`,
      },
    },
  },
  formCompliance: {
    // marginTop: "20px",
    marginLeft: "10px",
    // marginBottom: "-10px",
  },
  title: {
    // paddingBottom: "8px !important",
    // paddingTop: "24px !important",
    fontSize: "16px !important",
    fontFamily: "Poppins !important",
    color: "black !important",
    fontWeight: "500 !important",
    "&>p": {
      fontSize: "16px !important",
      fontFamily: "Poppins !important",
      color: "black !important",
      fontWeight: "500 !important",
    },
  },
  rsSugreryCreateBtn: {
    minWidth: "40px",
    width: "100%",
    "&>span": {
      margin: "0px !important",
    },
  },
  iconStyle: {
    "&>svg": {
      "&>rect": {
        fill: `${theme.palette.secondary.main} !important`,
      },
    },
  },
  iconCollection: {
    "&>svg": {
      "&>path": {
        fill: `${theme.palette.secondary.main} !important`,
      },
    },
  },
  chipsFilledNotCollect: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    background: `${theme.palette.primary.main}10 !important`,
    "&>svg": {
      "&>rect": {
        fill: ` ${theme.palette.primary.main} !important`,
      },
    },
  },
  chipsNotCollect: {
    borderColor: `${theme.palette.secondary.main} !important`,
    color: `${theme.palette.secondary.main} !important`,
    background: `${theme.palette.secondary.main}10 !important`,
    "&>svg": {
      "&>rect": {
        fill: `${theme.palette.secondary.main} !important`,
      },
    },
  },
  chipsFilledNot: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    background: `${theme.palette.primary.main}10 !important`,
    "&>svg": {
      "&>path": {
        fill: ` ${theme.palette.primary.main} !important`,
      },
    },
  },
  rsAddSurgery: {
    display: "flex",
    "&>button": {
      marginLeft: "5px",
      minWidth: "40px !important",
      height: "40px !important",
      width: "40px !important",
      marginTop: "7px",
    },
  },
  rsTextField: {
    marginBottom: "13px !important",
    width: "85px",
    // "&>label":{
    //   fontSize:"9px !important"
    // },
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: "-12px",
    },
  },
  quantity: {
    "&>div": {
      "&>label": {
        fontSize: "9px !important",
      },
    },
  },
  rsDrugAutoCompleteBoxEdit: {
    "&>div": {
      "&>label": {
        fontSize: "9px !important",
      },
    },
    marginBottom: "13px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginTop: "3px !important",
    },
  },
  rsDrugAutoCompleteBox: {
    "&>div": {
      "&>label": {
        fontSize: "9px !important",
      },
    },
    marginBottom: "9px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginTop: "3px !important",
    },
  },
  rsPrncheck: {
    margin: "0px !important",
    whiteSpace: "nowrap",
    // "&>span":{
    //   color:"rgba(38, 38, 38, 1)",
    // },
    "&>button": {
      fontSize: "16px !important",
      height: "30px !important",
      minWidth: "150px",
    },
    "&>div": {
      "&>button": {
        fontSize: "16px !important",
        height: "30px !important",
        minWidth: "150px",
      },
    },
  },
  rsPatientPaperGeneralInfoMedi: {
    // padding: "17px 13px 25px",
    paddingTop: "0px",
    // paddingBottom: "25px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    // marginBottom: "30px",
    "&>div": {
      "&>div": {
        "&>table": {},
      },
    },
  },
  rsPatientPaperTag: {
    // padding: "17px 13px 25px",
    width: "100%",
    paddingTop: "0px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    overflow: "auto",
    // marginBottom: "1px",
    marginBottom: "12px",
    // maxHeight: "248px",
    // maxHeight: "calc(34vh - 100px)",
    maxHeight: "calc(28vh - 100px)",
    // minHeight: "176px",
    minHeight: "142px",
    // marginTop: "25px",
    backgroundColor: theme.palette.background.default,
    "&>div": {
      "&>div": {
        "&>table": {},
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "50%",
      marginBottom: "0px",
      marginRight: "12px",
    },
    [theme.breakpoints.down("480")]: {
      width: "100%",
      marginBottom: "12px",
    },
  },
  rsTagDialog: {
    width: "100%",
    paddingTop: "0px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    overflow: "auto",
    marginBottom: "12px",
    maxHeight: "calc(26vh - 100px)",
    minHeight: "142px",
    backgroundColor: theme.palette.background.default,
    "&>div": {
      "&>div": {
        "&>table": {},
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "100%",
      marginBottom: "10px",
    },
    [theme.breakpoints.down("480")]: {
      width: "100%",
      marginBottom: "12px",
    },
  },
  rsPatientPaperTagSmall: {
    // padding: "17px 13px 25px",
    width: "100%",
    paddingTop: "0px",
    paddingRight: "13px",
    paddingLeft: "13px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    overflow: "auto",
    // marginBottom: "1px",
    marginBottom: "12px",
    // maxHeight: "248px",
    // maxHeight: "calc(34vh - 100px)",
    maxHeight: "calc(45vh - 100px)",
    // minHeight: "176px",
    minHeight: "142px",
    // marginTop: "25px",
    backgroundColor: theme.palette.background.default,
    "&>div": {
      "&>div": {
        "&>table": {},
      },
    },
    [theme.breakpoints.down("1100")]: {
      width: "50%",
      marginBottom: "0px",
      marginRight: "12px",
    },
    [theme.breakpoints.down("480")]: {
      width: "100%",
      marginBottom: "12px",
    },
  },
  rsMediValue: {
    paddingTop: "10px !important",
    [theme.breakpoints.down("700")]: {
      overflowX: "auto",
    },
    "&>table": {
      borderBottom: "1px solid #e0e0e0 !important",
      borderRight: "1px solid #e0e0e0 !important",
      "&>thead": {
        "&>tr": {
          "&>th": {
            padding: "10px 16px",
            borderTop: "1px solid #e0e0e0 !important",
            borderRight: "0px !important",
          },
        },
      },
      "&>tbody": {
        "&>tr": {
          "&>td": {
            borderRight: "0px !important",
          },
        },
      },
      [theme.breakpoints.down("700")]: {
        minWidth: "750px",
        overflowX: "auto",
      },
    },
  },
  rsbuttonPrn: {
    "&>div": {
      "&>label": {
        "&>button": {
          display: "none",
        },
      },
    },
    "&:hover": {
      "&>div": {
        "&>label": {
          "&>button": {
            display: "flex",
          },
          "&>div": {
            "&>button": {
              display: "none",
            },
          },
        },
      },
    },
  },
  titleMain: {
    paddingTop: "0px !important",
  },
  textFilledAlign: {
    paddingTop: "20px !important",
  },
  notePadding: {
    paddingTop: "20px !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // marginTop: "10px !important",
    "&>div": {
      margin: "0px",
    },
    "&>button": {
      marginLeft: "20px",
    },
  },
  mainContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("800")]: {
      flexDirection: "column !important",
    },
    [theme.breakpoints.down("1100")]: {
      flexDirection: "column !important",
    },
  },
  mainContainerDailog: {
    display: "flex",
    flexDirection: "row",
    "&>div:nth-child(1)": {
      marginLeft: "20px",
      // marginRight: "10px",
    },
    "&>div:nth-child(2)": {
      marginLeft: "12px",
      marginRight: "20px",
    },
    [theme.breakpoints.down("800")]: {
      flexDirection: "column !important",
      "&>div:nth-child(1)": {
        marginLeft: "0px",
      },
      "&>div:nth-child(2)": {
        marginLeft: "0px",
      },
    },
    // [theme.breakpoints.down("1100")]: {
    //   flexDirection: "column !important",
    // },
  },
  btnContainer: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: "center",
    justifyContent: "flex-start",
    // position: "relative",
    // marginTop: "29px",
    // bottom: "25px",
    // bottom: "7px",
    // right: "20px",
    position: "absolute",
    // bottom:"23px",
    bottom: "10px",
    // marginTop: "30px",
    width: "-webkit-fill-available !important",
    [theme.breakpoints.down("1100")]: {
      position: "relative",
      bottom: "0px",
      justifyContent: "center",
      marginTop: "30px",
      marginBottom: "30px",
    },
    "&>div": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  btnContainerSmall: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    position: "relative",
    marginTop: "30px",
    width: "-webkit-fill-available !important",
    [theme.breakpoints.down("1100")]: {
      position: "relative",
      bottom: "0px",
      justifyContent: "center",
      marginTop: "30px",
      marginBottom: "30px",
    },
    "&>div": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  btnContainerDailog: {
    display: "flex",
    flexDirection: "row",
    // justifyContent: "center",
    position: "relative",
    marginTop: "18px",
    // marginBottom: "18px",
    "&>div": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
    [theme.breakpoints.down("800")]: {
      justifyContent: "center",
    },
  },
  generalInfoContainer: {
    width: "36%",
    marginRight: "12px",
    marginLeft: "1px",
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
      "&>div:nth-child(1)": {
        maxHeight: "unset !important",
        overflow: "auto !important",
      },
    },
    [theme.breakpoints.between("480", "1100")]: {
      width: "100%",
      // marginTop: "10px",
      // marginBody: "10px",
      "&>div:nth-child(2)": {
        flexDirection: "row",
        marginBottom: "12px",
      },
    },
    "&>div:nth-child(1)": {
      // maxHeight: "450px",
      // maxHeight: "calc(54vh + 2px)",
      maxHeight: "calc(60vh + 2px)",
      // maxWidth: "calc(79vh + 4px)",
      overflow: "auto",
    },
  },
  generalInfoContainerSmall: {
    width: "36%",
    marginRight: "12px",
    marginLeft: "1px",
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
      "&>div:nth-child(1)": {
        maxHeight: "unset !important",
        overflow: "auto !important",
      },
    },
    [theme.breakpoints.between("480", "1100")]: {
      width: "100%",
      // marginTop: "10px",
      // marginBody: "10px",
      "&>div:nth-child(2)": {
        flexDirection: "row",
        marginBottom: "12px",
      },
    },
    "&>div:nth-child(1)": {
      // maxHeight: "450px",
      // maxHeight: "calc(54vh + 2px)",
      maxHeight: "calc(65vh + 2px)",
      // maxWidth: "calc(79vh + 4px)",
      overflow: "auto",
    },
  },
  generalInfoContainerDailog: {
    width: "42%",
    "&>div:nth-child(1)": {
      // maxHeight: "450px",
      // maxHeight: "calc(54vh + 2px)",
      maxHeight: "calc(43vh + 2px)",
      // maxWidth: "calc(79vh + 4px)",
      overflow: "auto",
    },
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
      "&>div:nth-child(1)": {
        maxHeight: "unset !important",
        overflow: "auto !important",
        "&>div": {
          "&>div:nth-child(2)": {
            "&>div": {
              marginTop: "10px !important",
            },
          },
          "&>div:nth-child(3)": {
            "&>div": {
              marginTop: "10px",
            },
          },
          "&>div:nth-child(4)": {
            "&>div": {
              marginTop: "10px",
            },
          },
          "&>div:nth-child(5)": {
            "&>div": {
              marginTop: "10px",
            },
          },
          "&>div:nth-child(6)": {
            "&>div": {
              marginTop: "10px",
            },
          },
        },
      },
    },
  },
  medicineContainer: {
    width: "64%",
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
    },
    [theme.breakpoints.down("1100")]: {
      width: "100%",
    },
    [theme.breakpoints.between("800", "1500")]: {
      "&>div:nth-child(1)": {
        maxHeight: "calc(56vh + 105px) !important",
      },
    },
    [theme.breakpoints.between("1500", "1600")]: {
      "&>div:nth-child(1)": {
        maxHeight: "calc(55vh + 120px) !important",
      },
    },
    [theme.breakpoints.between("1600", "1700")]: {
      "&>div:nth-child(1)": {
        maxHeight: "calc(54vh + 110px) !important",
      },
    },
    "&>div:nth-child(1)": {
      maxHeight: "calc(66vh + 105px)",
      overflow: "auto",
      marginBottom: "1px",
    },
  },
  medicineContainerSmall: {
    width: "64%",
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
    },
    [theme.breakpoints.down("1100")]: {
      width: "100%",
    },
    "&>div:nth-child(1)": {
      overflow: "auto",
      marginBottom: "1px",
    },
  },
  medicineContainerDialog: {
    width: "58%",
    [theme.breakpoints.down("800")]: {
      width: "100%",
      marginTop: "10px",
      marginBody: "10px",
      "&>div:nth-child(1)": {
        maxHeight: "unset !important",
      },
    },
    [theme.breakpoints.between("800", "1500")]: {
      "&>div:nth-child(1)": {
        maxHeight: "calc(60vh + 85px) !important",
      },
    },
    [theme.breakpoints.between("1500", "1600")]: {
      "&>div:nth-child(1)": {
        maxHeight: "calc(60vh + 85px) !important",
      },
    },
    [theme.breakpoints.between("1600", "1700")]: {
      "&>div:nth-child(1)": {
        maxHeight: "calc(60vh + 85px) !important",
      },
    },
    "&>div:nth-child(1)": {
      maxHeight: "calc(60vh + 110px)",
      overflow: "auto",
    },
    // "&>div:nth-child(1)": {
    //   maxHeight: "unset",
    //   overflow: "auto",
    // },
  },
  groupColorIcon: {
    padding: "10px",
    marginTop: "8px",
    marginBottom: "8px",
    marginLeft: "8px",
    marginRight: "5px",
    borderRadius: "3px !important",
  },
  colorPalette: {
    // position: "fixed",
    // top: '0px',
    // right: '0px',
    // bottom: '0px',
    // left: '0px',
    // left: "47%",
    // top: "35%  !important",
    zIndex: "10",
  },
  colorPaletteadd: {
    // position: "fixed",
    // top: '0px',
    // right: '0px',
    // bottom: '0px',
    // left: '0px',
    // left: "47%",
    // top: "41%  !important",
    zIndex: "1",
  },
  createTagsContainer: {
    width: "100%",
    display: "flex",
    // flexDirection:"column !important",
    paddingTop: "10px",
    // paddingLeft: "20px",
    "&>div": {
      width: "50%",
      // marginRight: "18px",
      "&>div": {
        "&>label": {
          fontSize: "9px !important",
        },
      },
    },
  },
  colorField: {
    marginLeft: "18px !important",
    // paddingTop: "20px !important",
    "&>div": {
      "&>div": {
        "&>input": {
          padding: "0px !important",
        },
        "&>div": {
          margin: "0px !important",
        },
        padding: "0px !important",
      },
    },
  },
  tag: {
    display: "flex",
    // background: "#7BC044",
    width: "fit-content",
    color: "white",
    minWidth: "80px",
    justifyContent: "center",
    alignItems: "center",
    padding: "1px 0px",
    margin: "8px 5px",
    borderRadius: "20px",
    "&>p": {
      marginRight: "10px",
      marginLeft: "10px",
      fontSize: "12px",
    },
    "&>svg": {
      marginRight: "10px",
      marginLeft: "2px",
      stroke: "white",
    },
  },
  defaultTag: {
    display: "flex",
    // background: "#7BC044",
    width: "fit-content",
    color: "white",
    minWidth: "80px",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px 0px",
    margin: "8px 5px",
    borderRadius: "20px",
    cursor: "pointer",
    "&>p": {
      marginRight: "10px",
      marginLeft: "10px",
      fontSize: "12px",
      "-webkit-user-select": "none" /* Safari */,
      "-ms-user-select": "none",
      userSelect: "none" /* Standard syntax */,
    },
  },
  tagsContainer: {
    display: "flex",
    // marginTop: "10px",
    paddingTop: "0px",
    paddingBottom: "10px",
    // paddingLeft: "20px",
    "&>h6": {
      fontSize: "10px !important",
    },
    "&>div": {
      "&>div": {
        "&>button": {
          padding: "8px 17px !important",
        },
      },
    },
  },
  tagsContainerDailog: {
    display: "flex",
    paddingTop: "0px",
    "&>h6": {
      fontSize: "10px !important",
    },
    "&>div": {
      "&>div": {
        "&>button": {
          padding: "8px 17px !important",
        },
      },
    },
  },
  rsTagGrid: {
    paddingTop: "25px",
    paddingLeft: "20px",
  },
  inputGrid: {
    display: "flex",
    "&>div": {
      "&>div": {
        "&>label": {
          fontSize: "9px !important",
        },
      },
    },
    [theme.breakpoints.down("800")]: {
      // background:"red",
      flexDirection: "column !important",
      "&>div:nth-child(2)": {
        margin: "0px !important",
      },
      "&>div:nth-child(3)": {
        margin: "0px !important",
      },
    },
    "&>div:nth-child(2)": {
      marginLeft: "18px",
      // marginRight: "8.5px",
    },
    "&>div:nth-child(3)": {
      // marginLeft: "8.5px",
      marginLeft: "18px",
      // marginRight: "18px",
    },
  },
  closeIcon: {
    "&>svg": {
      height: "30px",
      width: "30px",
      stroke: "grey",
    },
  },
  radioGroup: {
    // width: "max-content",
    display: "flex",
    alignItems: "flex-start",
    "&>div": {
      "&>label": {
        marginRight: "13px !important",
      },
      "&>div": {
        [theme.breakpoints.down("800")]: {
          display: "flex",
          flexDirection: "column !important",
        },
        "&>label": {
          "&>span:nth-child(2)": {
            fontSize: "14px !important",
            // color: "black",
          },
        },
      },
    },
    "&>label": {
      "&>span:nth-child(2)": {
        fontSize: "14px !important",
        // color: "black",
      },
    },
    // "&>div": {
    //   width:"max-content"
    // },
    "&>p": {
      marginTop: "10px",
      marginBottom: "5px",
    },
  },
  inputGridResponsive: {
    display: "flex",
    paddingTop: "5px !important",
    "&>div": {
      "&>div": {
        "&>label": {
          fontSize: "9px !important",
        },
        "&>div:nth-child(1)": {
          height: "unset !important",
        },
      },
    },
    [theme.breakpoints.down("800")]: {
      flexDirection: "column !important",
      paddingTop: "0px !important",
      "&>div:nth-child(1)": {
        margin: "0px",
      },
      "&>div:nth-child(2)": {
        maxWidth: "100%",
      },
    },
  },
  surgeryAutocompleteGrid: {
    // margin: "0px 17px",
    [theme.breakpoints.down("800")]: {
      margin: "0px",
    },
  },
  resPatientTypeGrid: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    [theme.breakpoints.down("800")]: {
      flexDirection: "column !important",
    },
  },
  iconBtn: {},
  card: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    cursor: "pointer  !important",
    borderRadius: "8px !important",
    // borderColor: `${theme.palette.secondary.main} !important`,
    color: `#262626 !important`,
    // background: `${theme.palette.secondary.main}10 !important`,
    border: " 1px solid rgba(80, 80, 80, 0.6) !important",
    "& .MuiChip-icon": {
      margin: "0px !important",
    },
    "&>svg": {
      width: "20px",
      height: "20px",
    },
    "&>span": {
      margin: "0px  !important",
      padding: "0px  !important",

      "&>div": {
        "&>svg": {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "18px",
          height: "18px",
        },
      },
    },
    "&:hover": {
      background: `${theme.palette.primary.main}25 !important`,
      borderColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.primary.main} !important`,
      background: `${theme.palette.primary.main}10 !important`,
      "&>svg": {
        "&>path": {
          fill: ` ${theme.palette.primary.main} !important`,
        },
      },
    },
    "&>div:nth-child(1)": {
      height: "min-content",
      paddingRight: "10px",
      // paddingTop:"5px",
      "&>div": {
        "&>button": {},
      },
    },
    "&>div:nth-child(2)": {
      // display: "flex",
      // flexDirection: "column",
      // justifyContent: "center",
      // alignItems: "center",
      padding: "0px",
      paddingLeft: "5px",
      // paddingTop: "5px",
      // paddingBottom: "5px",
      "&>svg": {
        height: "22px",
        paddingBottom: "5px",
        "&>path": {
          fill: `${theme.palette.secondary.main} !important`,
        },
      },
      "&>div": {
        padding: "0px 6px",
        "&>button": {},
      },
    },
  },
  mainPopper: {
    zIndex: "1600",
  },
  noteContainerDailog: {
    display: "flex",
    marginTop: "2px",
    "&>div": {
      "&>button": {
        padding: "8px 15px !important",
        // textTransform: "uppercase",
        fontWeight: "600 !important",
        "&>span": {
          // marginRight:"0px !important"
        },
      },
    },
  },
  noteContainer: {
    display: "flex",
    marginTop: "2px",
    marginBottom: "12px",
    "&>div": {
      "&>button": {
        padding: "8px 15px !important",
        // textTransform: "uppercase",
        fontWeight: "600 !important",
        "&>span": {
          // marginRight:"0px !important"
        },
      },
    },
  },
  toolTip: {
    // color:"white !important"
  },
  checkboxLabel: {
    "& .MuiFormControlLabel-label": {
      whiteSpace: "nowrap",
      fontSize: "14px !important",
      fontFamily: "Poppins !important",
    },
  },
  noteBtn: {
    marginBottom: "15px !important",
    marginTop: "11px !important",
  },
  LastOrderdate: {
    display: "flex",
    // width: "63%",
    justifyContent: "end",
    // marginTop: "5px",
    // marginBottom: "-25px",
    "&>h6": {
      color: "#7BC044 !important",
      fontWeight: "600 !important",
      fontSize: "14px !important",
      marginRight: "5px !important",
    },
    "&>h5": {
      color: "#262626 !important",
      fontWeight: "400 !important",
      fontSize: "14px !important",
    },
  },
  LastOrderdateCondition: {
    display: "flex",
    // width: "63%",
    justifyContent: "end",
    // marginTop: "5px",
    // marginBottom: "-25px",
    "&>h6": {
      color: "#7BC044 !important",
      fontWeight: "600 !important",
      fontSize: "14px !important",
      marginRight: "5px !important",
    },
    "&>h5": {
      color: "#262626 !important",
      fontWeight: "400 !important",
      fontSize: "14px !important",
    },
  },
  quantity: {
    marginTop: "0px !important",
    "&>div": {
      marginTop: "0px !important",
    },
  },
  // quantityEdit: {
  //   marginTop: "9px !important",
  // },
  rsQtyContainer: {
    marginTop: "9px !important",
  },
  groupAutoCompleteBox: {
    "&>div": {
      "&>label": {
        [theme.breakpoints.down("1780")]: {
          maxWidth: "calc(57% - 24px)",
        },
        [theme.breakpoints.down("1575")]: {
          maxWidth: "calc(55% - 24px)",
        },
        [theme.breakpoints.down("1400")]: {
          maxWidth: "calc(52% - 24px)",
        },
        [theme.breakpoints.down("1260")]: {
          maxWidth: "calc(50% - 24px)",
        },
      },
    },
  },
}));

const PatientsCreateAndEdit = (props) => {
  const {
    getPatientListAction,
    createPatientAction,
    resetPatientState,
    createPatientData,
    updatePatientAction,
    updatePatientData,
    getSinglePatientAction,
    singlePatientData,
    callBackOnSubmit,
    callBackOnCancel,
    _patientId,
    orderActionType,
    getPharmacyListAction,
    getSGroupListAction,
    _pageAccessMode,
    openImportCsvPatientForm,
    createNewPatientFromCSV,
    getHomeListAction,
    getOrderListAction,
    getCollectionRxAction,
    fromPatientDetails,
    getPharmaciesListAction,
    dialog,
    getOrderCountTypeAction,
    orderCountPayload,
    countUpdateFlag,
    drugFieldList,
    getDrugFieldListAction,
  } = props;
  const classes = useStyle();
  const navigate = useNavigate();
  const query = new URLSearchParams(window.location.search);
  const [notesArray, setNotesArray] = useState([]);
  const [notesEdit, setNotesEdit] = useState(false);
  const [installmentType, setInstallmentType] = useState(false);
  const [isSignleDataApiProgress, setIsSignleDataApiProgress] = useState(false);
  const [showColorPalette, setShowColorPalette] = useState(false);
  const [tags, setTags] = useState([]);
  const [deleteTags, setDeleteTags] = useState([]);
  const [selected, setSelected] = React.useState(false);
  const [col, setCol] = useState("");
  const [noteLength, setNoteLength] = useState(0);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const { width } = useViewport();
  const height = window.innerHeight;
  const formState = {
    name: "",
    middle_name: "",
    last_name: "",
    dob: null,
    address: "",
    surgery_id: "",
    surgery_info: {},
    pharmacy_id: "",
    pharmacy_info: {},
    phn_number: "",
    group_id: "",
    group_info: {},
    notes: "",
    drug: "",
    drug_info: {},
    quantity: "",
    status: "active",
    type: "",
    is_urgent: false,
    compliance_aid: false,
    installment_dispensing: "weekly",
    g_color_code: "#000000",
    nhs_number: "",
  };
  const [createDrug, setCreateDrug] = useState(false);
  const [patientData, setPatientData] = useState(formState);
  const [isOpenStatusList, setIsOpenStatusList] = useState(false);
  const [isOpenPatientTypeList, setIsOpenPatientTypeList] = useState(false);
  const [installmentDispensingList, setInstallmentDispensingList] =
    useState(false);
  const [medications, setMedications] = useState([]);
  const [medicationId, setMedicationId] = useState([]);
  const [editMedication, setEditMedication] = useState({});
  const [isOpenPharmacyAutocomplete, setIsOpenPharmacyAutocomplete] =
    useState(false);
  const [deleteMedication, setDeleteMedication] = useState([]);
  const [deleteNote, setDeleteNote] = useState([]);
  const [isOpenDate, setIsOpenDate] = React.useState(false);
  const [isOpenSurgeryModel, setIsOpenSurgeryModel] = useState(false);
  const [surgeryRecordActionType, setSurgeryRecordActionType] = useState("");
  const [patientInfoActionType, setPatientInfoActionType] = useState("");
  const [listOpen, setListOpen] = useState(false);
  const loginUserDetail = useSelector((state) => state.user);
  const [subscriptionDialog, setSubscritionDialog] = useState(false);
  const [addPharmacy, setAddPharmacy] = useState(false);
  const [editPharmacyData, setEditPharmacyData] = useState({});
  const [isOpenGroupModel, setIsOpenGroupModel] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(false);
  const [openNotesDailog, setOpenNotesDailog] = useState(false);
  const [openTagDialog, setOpenTagDialog] = useState(false);
  const [notesData, setNotesData] = useState({
    title: "",
    index: null,
    data: "",
  });
  const [editGroupData, setEditGroupData] = useState({});
  const [defaultTags, setDefaultTags] = useState({
    delivery: false,
    collection: false,
    compliance_aid: false,
  });
  // const colorPaletteRef = useRef(null);
  const anchorRef = useRef(null);
  const screenWidth = window.innerWidth;
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  const blankNotes = notesArray.filter((item) => {
    return item?.notes?.trim() === "";
  });
  const [isOpenSurgeyAutocomplete, setIsOpenSurgeyAutocomplete] =
    useState(false);
  const blankMediation = medications.filter((item) => {
    return item?.name?.trim() === "";
  });

  const redirectToPatientList = () => {
    navigate("/patients");
  };
  const PatientType = [
    { item: "Delivery", type: "delivery", icon: <Delivery /> },
    { item: "Collection", type: "collection", icon: <CollectionIcon /> },
  ];

  const InstallmentTypes = [
    { item: "Daily", type: "daily", icon: <Daily /> },
    { item: "Weekly", type: "weekly", icon: <Weekly /> },
    { item: "Twice weekly", type: "twice_weekly", icon: <TwiceWeek /> },
    {
      item: "Three time a  week",
      type: "three_times_a_week",
      icon: <ThriceWeek />,
    },
    { item: "Fortnightly", type: "fortnightly", icon: <Fortnightly /> },
  ];
  /** Use ref form fields */
  const PharmacyRef = useRef(null);
  const quantityRef = useRef(null);
  const medicationRef = useRef(null);
  const SurgeryRef = useRef(null);
  const patientId = _patientId ? _patientId : query.get("patientId");
  const pageAccessMode =
    typeof _pageAccessMode !== "undefined"
      ? _pageAccessMode
      : _patientId
      ? "edit"
      : query.get("actionType");
  /** call api  */
  useLayoutEffect(() => {
    if (pageAccessMode === "create") {
      // setNotesArray([
      //   {
      //     notes: "",
      //   },
      // ]);
      if (medications.length === 0) {
        handleClickAddDrug();
      }
    } else if (pageAccessMode === "edit") {
      if (patientId) {
        /** API call */
        setIsSignleDataApiProgress(true);
        getSinglePatientAction(patientId);
      } else {
        /** Redirect to patients page */
        redirectToPatientList();
      }
    }
  }, []);
  /** validate drug */
  const validateDrug = (validationCheckFor = "submit") => {
    if (validationCheckFor === "onChange") {
      const _validateMedication = medications?.map((item) => {
        return (item = {
          ...item,
          errors: {
            name: "",
            quantity: "",
          },
        });
      });
      setMedications(_validateMedication);
      return 0;
    }

    let errorCounter = 0;
    const _validateMedication = medications?.map((item) => {
      if (validationCheckFor === "add") {
        if (
          item.name.trim() === "" ||
          item.quantity == "" ||
          item.quantity == null
        ) {
          errorCounter++;
        }
      } else {
        item.errors = {
          name: "",
          quantity: "",
        };

        if (
          item.name.trim() === "" &&
          item.quantity !== "" &&
          item.quantity !== null
        ) {
          errorCounter++;
          item.errors.name = "Please enter medication";
        } else if (item.name.trim() !== "") {
          // if (item.quantity == "" || item.quantity == null) {
          //   errorCounter++;
          //   // item.errors.quantity = "Please enter quantity";
          // } else
          if (item.quantity && item.quantity <= 0) {
            errorCounter++;
            item.errors.quantity = "The quantity  must be greater than 0.";
          }
          //  else if (isNaN(item.quantity)) {
          //   item.errors.quantity = "The quantity must be a number.";
          //   errorCounter++;
          // }
        }
      }
      return item;
    });
    setMedications(_validateMedication);
    return errorCounter;
  };

  let notesCreateSchema = yup.object().shape({
    0: yup.string().required("The Notes field is required."),
  });

  /* Validation Schema */
  let adminSchema = {
    name: yup.string().required("The first name field is required."),
    last_name: yup.string().required("The last name field is required."),
    dob: yup
      .date()
      .nullable()
      .typeError("Date must be in DD-MM-YYYY format")
      .max(new Date(), "The DOB can not be the future date"),
    surgery_id: yup.string().required("The surgery field is required."),
    pharmacy_id: yup.string().required("The pharmacy field is required."),
    // phn_number: yup.string().required("The Phone Number is required."),
    tags_title: openTagDialog
      ? yup.string().required("The tag title is required.")
      : "",
    g_color_code: openTagDialog
      ? yup.string().required("Color code is required.")
      : "",
  };

  /* Other Validation Schema */
  let otherDetailsSchema = {
    name: yup.string().required("The first name field is required."),
    last_name: yup.string().required("The last name field is required."),
    dob: yup
      .date()
      .nullable()
      .typeError("Date must be in DD-MM-YYYY format")
      // .required("The date of birth field is required.")
      .max(new Date(), "The DOB can not be the future date"),
    surgery_id: yup.string().required("The surgery field is required."),
    tags_title: openTagDialog
      ? yup.string().required("The tag title is required.")
      : "",
    g_color_code: openTagDialog
      ? yup.string().required("Color code is required.")
      : "",
    // phn_number: yup.string().required("The Phone Number is required."),
  };
  /* Condition Based on validation schema  */
  let schema = {};
  if (loginUserDetail?.loginUserDetail?.data?.data?.is_new_user === false) {
    schema = adminSchema;
  } else if (
    ["pharmacy", "pharmacist_staff", "pharmacist"].indexOf(
      showDataBasedOnRole
    ) !== -1 ||
    loginUserDetail?.loginUserDetail?.data?.data?.is_new_user === true
  ) {
    schema = otherDetailsSchema;
  } else {
    schema = {
      ...adminSchema,
      ...otherDetailsSchema,
    };
  }

  /* Schema  */
  const patientSchema = yup.object().shape({ ...schema });

  useEffect(() => {
    if (pageAccessMode === "create") {
      setTimeout(() => {
        document.getElementById("name")?.focus();
      }, 500);
    }
  }, []);

  /** handle add patient */
  const handleAddPatient = (formValues) => {
    // if (loginUserDetail?.loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    setCol("action");
    /** Validate drugs */
    if (validateDrug() > 0) {
      return false;
    }
    const payload = {
      name: formValues?.name,
      last_name: formValues?.last_name,
      dob: formValues?.dob
        ? moment(new Date(formValues?.dob)).format("YYYY-MM-DD")
        : null,
      surgery_id: formValues?.surgery_id,
      status: formValues?.status,
      is_urgent: formValues?.is_urgent,
      compliance_aid: formValues?.compliance_aid,
      phn_number: formValues?.phn_number,
      nhs_number: formValues?.nhs_number,
      address: formValues?.address,
    };
    if (
      ["admin", "super_admin"].indexOf(showDataBasedOnRole) !== -1 ||
      loginUserDetail?.loginUserDetail?.data?.data?.is_new_user === false
    ) {
      payload.pharmacy_id = formValues?.pharmacy_id;
    }

    if (installmentType == true) {
      payload.instalment_type = formValues?.installment_dispensing;
    }
    if (_pageAccessMode === "importCsvPatient") {
      payload.temp_patient_id = createNewPatientFromCSV?.tp_id;
    }

    if (formValues.middle_name) {
      payload.middle_name = formValues?.middle_name;
    }
    if (medications.length > 0) {
      const medicines = medications.filter((item) => {
        delete item.errors;
        if (item.name.trim() !== "") {
          return item;
        }
      });
      if (medicines.length > 0) {
        let allDrug = medications.filter((item) => {
          if (item.changeable_prn == true) {
            return item;
          } else {
            item.changeable_prn = false;
            return item;
          }
        });
        // setMedications(allDrug);
        payload.drug = allDrug;
      }
    }

    if (formValues.type?.length > 0) {
      payload.type = formValues.type;
    }

    if (formValues.group_id?.length > 0) {
      payload.group_id = formValues.group_id;
    }

    // Tags
    if (pageAccessMode === "edit") {
      if (tags?.length > 0) {
        const temp = tags
          .filter((tag) => typeof tag.id === "number")
          .map((tag) => ({
            pit_name: tag.title,
            pit_colour_code: tag.colour,
          }));
        if (temp.length > 0) {
          payload.tags = temp;
        }
      }
      if (deleteTags?.length > 0) {
        payload.delete_tags = deleteTags;
      }
    } else {
      if (
        tags?.length > 0 ||
        defaultTags.delivery ||
        defaultTags.collection ||
        defaultTags.compliance_aid
      ) {
        const temp = tags.map((tag) => ({
          pit_name: tag.title,
          pit_colour_code: tag.colour,
        }));
        const defaultTagsArray = [];
        if (defaultTags.delivery === true) {
          defaultTagsArray.push({
            pit_name: "Delivery",
            pit_colour_code: "#4644C0",
          });
        }
        if (defaultTags.collection === true) {
          defaultTagsArray.push({
            pit_name: "Collection",
            pit_colour_code: "#FFB82F",
          });
        }
        if (defaultTags.compliance_aid === true) {
          defaultTagsArray.push({
            pit_name: "Compliance Aid",
            pit_colour_code: "#6B8535",
          });
        }
        payload.tags = [...defaultTagsArray, ...temp];
      }
    }

    /** Start code for new notes */
    const removeIdNewNotes = notesArray.map((item) => {
      if (typeof item.id === "number") {
        return { notes: item.notes };
      }
      return item;
    });
    const fillterdNotes = removeIdNewNotes.filter((item) => {
      if (item.hasOwnProperty("id") === false) {
        return item.notes !== "";
      }
    });
    if (fillterdNotes.length > 0) {
      payload.notes = fillterdNotes.map((item) => {
        return item.notes;
      });
    }
    /** End code for new notes */

    /** Update note payload */
    if (pageAccessMode === "edit") {
      const updateNoteMapping = removeIdNewNotes
        .filter((item) => {
          if (item.hasOwnProperty("id") === true) {
            return item.notes !== "";
          }
        })
        ?.map((item) => {
          return {
            id: item.id,
            notes: item.notes,
          };
        });

      if (updateNoteMapping?.length > 0) {
        payload.update_notes = updateNoteMapping;
      }
      // if (notesArray?.length === 1) {
      //   let temp = notesArray?.map((item) => {
      //     if (item.notes === "") {
      //       if (item.id) {
      //         payload.delete_notes = [item.id];
      //       }
      //     }
      //   });
      // }
      if (deleteNote.length > 0) {
        payload.delete_notes = deleteNote;
      }
    }

    if (pageAccessMode === "edit" && deleteMedication.length > 0) {
      payload.delete_medication = deleteMedication;
    }

    if (
      pageAccessMode === "edit" &&
      Object.keys(singlePatientData)?.length > 0
    ) {
      updatePatientAction(patientId, payload);
    } else {
      createPatientAction(payload);
    }
    // }
  };

  const { guardedSubmit: xssGuardedAddPatient } = useXssGuard(handleAddPatient);

  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    resetForm,
    setErrors,
    setFieldValue,
    handleBlur,
  } = useFormik({
    initialValues: { ...patientData },
    validationSchema: patientSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedAddPatient,
  });

  /** handle click add note */
  const handleClickAddNote = (created_value) => {
    if (created_value.length <= 0) {
      setErrors({
        notes: "The Notes field is required.",
      });
      return;
    }
    if (created_value) {
      // if(pageAccessMode === "create"){
      setFieldValue("notes", {
        ...notesArray,
        [notesArray.length]: created_value,
      });
      // }
      setNotesArray(
        notesArray.concat([
          {
            id: notesArray.length,
            notes: created_value,
          },
        ])
      );
    } else {
      setNotesArray(
        notesArray.concat([
          {
            notes: "",
          },
        ])
      );
    }
  };

  // console.log("notesData", notesData);
  // console.log("values.notes", values);

  /** handle click add drug  */
  const handleClickAddDrug = () => {
    setMedications(
      medications.concat([
        {
          id: "",
          name: "",
          quantity: "",
          errors: {
            name: "",
            quantity: "",
          },
        },
      ])
    );
  };

  /** handle drug change */
  const handleDrugChange = (e, index, rowInfo) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      ...(rowInfo
        ? {
            ...rowInfo,
            meditation_id: rowInfo.id,
            id: null,
          }
        : {
            id: "",
            name: "",
            meditation_id: "",
          }),
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  /** get medication */
  useEffect(() => {
    const drugIds = medications
      .filter((item) => {
        if (item.meditation_id && item.meditation_id !== "") {
          return item;
        }
      })
      .map((item) => {
        return item.meditation_id;
      });

    setMedicationId(drugIds);
  }, [medications]);

  /** handle change quantity */
  const handleChangeQuantity = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      quantity: e.target.value,
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  /** Remove note Function */
  const handleClickRemoveNote = (removeIndex) => {
    if (notesArray[removeIndex].hasOwnProperty("id")) {
      setDeleteNote([...deleteNote, notesArray[removeIndex].id]);
    }
    const newData = notesArray.filter((item, index) => index !== removeIndex);
    setNotesArray(newData);
    setOpenConfirm(false);
  };

  /** handle note changes */
  const handleNoteChange = (e, index, rowInfo) => {
    const allNotes = notesArray;
    allNotes[index] = {
      ...allNotes[index],
      notes: e.target.value,
    };
    setNotesArray([...allNotes]);
  };

  useEffect(() => {
    if (pageAccessMode === "create") {
      setMedications([
        {
          id: "",
          name: "",
          quantity: "",
          errors: {
            name: "",
            quantity: "",
          },
        },
      ]);
    }
  }, []);

  /** Edit patient data store useeffect */
  useEffect(() => {
    if (pageAccessMode === "edit" || orderActionType === "orderInfo") {
      setMedications([]);
    }
    if (
      (pageAccessMode === "edit" &&
        Object.keys(singlePatientData?.data)?.length > 0) ||
      orderActionType === "orderInfo"
    ) {
      const patientStatus = statusMenuItems?.filter((item, index) => {
        return item.label === singlePatientData?.data?.status;
      });

      const patientType = patientTypeMenuItems?.filter((item, index) => {
        return item.value === singlePatientData?.data?.type;
      });

      let notes = [
        {
          notes: "",
        },
      ];
      if (singlePatientData?.data?.notes?.length > 0) {
        notes = singlePatientData?.data?.notes?.map((value) => {
          return {
            id: value.id,
            notes: value.notes,
            created_at: value.created_at,
            created_by: value.created_by,
          };
        });
      }
      if (notes[0].notes !== "") {
        setNotesArray(notes);
      }
      // setNotesArray(notes);
      if (singlePatientData?.data?.tags?.length > 0) {
        let tagsArr = [];
        singlePatientData?.data?.tags?.map((tag, index) => {
          let obj = {
            id: tag.pit_id,
            colour: tag.pit_colour_code,
            title: tag.pit_name,
          };
          tagsArr.push(obj);
        });
        setTags(tagsArr);
      } else {
        setTags([]);
      }
      setPatientData({
        name: singlePatientData?.data?.name || "",
        middle_name: singlePatientData?.data?.middle_name || "",
        last_name: singlePatientData?.data?.last_name || "",
        dob: singlePatientData?.data?.dob || "",

        notes: notes,
        surgery_id: singlePatientData?.data?.surgery?.id || "",
        surgery_info: singlePatientData?.data?.surgery,
        pharmacy_id: singlePatientData?.data?.pharmacy?.id || "",
        pharmacy_info: singlePatientData?.data?.pharmacy,
        address: singlePatientData?.data?.address || "",
        status: patientStatus[0]?.value,
        type: patientType[0]?.value,
        group_id: singlePatientData?.data?.g_id || "",
        group_info: {
          g_id: singlePatientData?.data?.g_id,
          g_name: singlePatientData?.data?.g_name,
        },
        is_urgent: singlePatientData?.data?.is_urgent,
        installment_dispensing:
          singlePatientData?.data?.instalment_type || "weekly",
        compliance_aid: singlePatientData?.data?.compliance_aid,
        g_color_code: "#000000",
        phn_number: singlePatientData?.data?.phone || "",
        nhs_number: singlePatientData?.data?.nhs_number || "",
      });
      if (singlePatientData?.data?.compliance_aid === true) {
        setSelected(true);
      }
      if (singlePatientData?.data?.instalment_type) {
        setInstallmentType(true);
      }
      const medications =
        singlePatientData?.data?.drugs?.map((item) => {
          return {
            ...item,
            errors: {
              name: "",
              quantity: "",
            },
          };
        }) || [];

      if (medications.length === 0) {
        handleClickAddDrug();
      } else {
        /**filter duplicate drugs */
        const uniqueMeditation = medications.reduce((accumulator, current) => {
          if (!accumulator.find((item) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);
        setMedications(uniqueMeditation);
      }
    }
  }, [singlePatientData?.data]);

  /** If user has change edit id then show error message & redirect to patient listing page */
  useEffect(() => {
    if (!singlePatientData.isRecordFound && isSignleDataApiProgress) {
      redirectToPatientList();
    }
  }, [singlePatientData.isRecordFound]);

  /** Sucess useeffect & reset reducer State */
  useEffect(() => {
    if (col === "action") {
      if (
        (!createPatientData?.loading &&
          Object.keys(createPatientData?.data || {})?.length > 0) ||
        (!updatePatientData?.loading &&
          Object.keys(updatePatientData?.data || {})?.length > 0)
      ) {
        resetPatientState("createPatientData", "");
        resetPatientState("updatePatientData", "");
        resetPatientState("singlePatientData");
        setMedications([]);
        resetForm();
        setErrors({});
        setEditMedication({});
        if (countUpdateFlag) {
          getOrderCountTypeAction(orderCountPayload);
        }
      }
    }
  }, [createPatientData, updatePatientData]);

  /** User create & patient sucess useeffect redirect patient listing page */
  useEffect(() => {
    let payLoad = {
      offset: 0,
      limit: 20,
    };
    let payloadPatient = {
      offset: 0,
      limit: 20,
    };
    let payload = {};
    let repeatOrderPayload = {
      offset: 0,
      type: "all",
      limit: 20,
    };
    let payloadCollect = {
      offset: 0,
      is_chase_up: getLocalStorage("chaseUp") === "true" ? true : false,
      type: "un_collected",
      limit: 20,
    };
    if (col === "action") {
      if (
        createPatientData?.data?.success === true ||
        updatePatientData?.data?.success
      ) {
        if (typeof callBackOnSubmit === "function") {
          const responseData =
            pageAccessMode === "create"
              ? createPatientData?.data?.data
              : updatePatientData?.data?.data;
          callBackOnSubmit(responseData);
          // On edit, skip list API — reducer already updates in-place via SUCCESS_UPDATE_PATIENT
          if (pageAccessMode !== "edit") {
            if (
              selectedHeaderPharmacyId !== "" &&
              selectedHeaderPharmacyId !== "all"
            ) {
              payloadPatient = {
                offset: 0,
                pharmacy_id: [selectedHeaderPharmacyId],
              };
              setLocalStorage("isPatientCreated", "true");
              getPatientListAction(payloadPatient);
            } else {
              setLocalStorage("isPatientCreated", "true");
              getPatientListAction(payloadPatient);
            }
          }else{
            setLocalStorage("isPatientEdit", "true");
          }
          // getPatientListAction(payloadPatient);
          getPharmacyListAction(payLoad);
          getHomeListAction(payload);
          getCollectionRxAction(payloadCollect);
        } else {
          redirectToPatientList();
          // On edit, skip list API — reducer already updates in-place via SUCCESS_UPDATE_PATIENT
          if (pageAccessMode !== "edit") {
            if (
              selectedHeaderPharmacyId !== "" &&
              selectedHeaderPharmacyId !== "all"
            ) {
              payloadPatient = {
                offset: 0,
                pharmacy_id: [selectedHeaderPharmacyId],
              };
              setLocalStorage("isPatientCreated", "true");
              getPatientListAction(payloadPatient);
            } else {
              setLocalStorage("isPatientCreated", "true");
              getPatientListAction(payloadPatient);
            }
          }else{
            setLocalStorage("isPatientEdit", "true");
          }
          // getPatientListAction(payloadPatient);
          // getPharmacyListAction(payLoad);
          // getHomeListAction(payload);
          // getOrderListAction(repeatOrderPayload);
          // getCollectionRxAction(payloadCollect);
        }
      }
    }
  }, [createPatientData?.data?.success, updatePatientData?.data?.success]);

  useEffect(() => {
    const errors =
      pageAccessMode === "create" || _pageAccessMode === "importCsvPatient"
        ? createPatientData?.error?.errors
        : updatePatientData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [createPatientData?.error, updatePatientData.error]);

  /**handle server error */
  const returnServerError = (errorKey) => {
    let errorObj = {
      keyPresent: false,
      message: "",
    };
    let errorBag =
      pageAccessMode === "create" || _pageAccessMode === "importCsvPatient"
        ? createPatientData?.error?.errors
        : updatePatientData?.error?.errors;
    let updateState = {
      loading: false,
      data: {},
      error: "",
    };
    if (errorKey == "") {
      resetPatientState("createPatientData", updateState);
      resetPatientState("updatePatientData", updateState);
    } else if (errorBag?.hasOwnProperty(errorKey)) {
      if (errorKey == "name") {
        if (
          errorBag?.[errorKey]?.[0] ==
          "The given name or date of birth are exists. Please enter unique name or date of birth."
        ) {
          resetPatientState("createPatientData", updateState);
          resetPatientState("updatePatientData", updateState);
        }
      } else {
        errorObj = {
          keyPresent: true,
          message: errorBag?.[errorKey]?.[0],
        };
      }
    }
    return errorObj;
  };

  /** Durg add Object */
  const handleOnAddDrug = (drugObject, editMedication) => {
    let medicationData = medications;
    if (isEmptyObject(editMedication)) {
      medicationData.push(drugObject);
    } else {
      medicationData[editMedication.indexNo] = drugObject;
    }
    setMedications(medicationData);
  };

  /** handle set create drug data  */
  useEffect(() => {
    if (!createDrug) {
      setEditMedication({});
    }
  }, [createDrug]);

  /** Remove drug */

  const handleClickRemoveDrug = (removeDrugIndex, drugId) => {
    const newData = medications.filter(
      (item, index) => index !== removeDrugIndex
    );
    /** push drugId */
    setMedications(newData);
    if (drugId && medications !== "") {
      let ids = deleteMedication;
      ids.push(drugId);
      setDeleteMedication(ids);
    }
  };

  /** Status Drop-down set value function */
  const selectedRoleOption = () => {
    if (values?.status !== "") {
      const otpion = statusMenuItems.filter((item) => {
        return item.value === values?.status;
      });
      if (otpion.length > 0) {
        return otpion[0].label;
      }
    }
    return "";
  };

  /** handle call back on submit info */
  const callBackOnSubmitSurgeryInfo = (sureryInfo) => {
    const data = sureryInfo.data;
    const { email, id, name } = data;
    setFieldValue("surgery_info", {
      id,
      email,
      name,
    });
    setFieldValue("surgery_id", id);
  };

  useEffect(() => {
    if (openImportCsvPatientForm && !fromPatientDetails) {
      setPatientData({
        name: createNewPatientFromCSV?.tp_other_detail?.first_name || "",
        middle_name:
          createNewPatientFromCSV?.tp_other_detail?.middle_name || "",
        last_name: createNewPatientFromCSV?.tp_other_detail?.last_name || "",
        dob: createNewPatientFromCSV?.tp_other_detail?.dob || "",
        address: createNewPatientFromCSV?.tp_other_detail?.address || "",
        surgery_id: createNewPatientFromCSV?.surgery_detail?.id,
        surgery_info: createNewPatientFromCSV?.surgery_detail,
        pharmacy_id: "",
        pharmacy_info: "",
        compliance_aid: false,
        status: "active",
        g_color_code: "#000000",
        phn_number: "",
        nhs_number: "",
      });

      const medications =
        createNewPatientFromCSV?.tp_other_detail?.medication?.map((item) => {
          return {
            name: item?.name,
            quantity: item?.quantity,
          };
        }) || [];

      if (medications.length === 0) {
        handleClickAddDrug();
      } else {
        /**filter duplicate drugs */
        const uniqueMeditation = medications.reduce((accumulator, current) => {
          if (!accumulator.find((item) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);
        setMedications(uniqueMeditation);
      }
    }
  }, [openImportCsvPatientForm]);

  useEffect(() => {
    if (fromPatientDetails) {
      const patientStatus = statusMenuItems?.filter((item, index) => {
        return item.label === singlePatientData?.data?.status;
      });

      const patientType = patientTypeMenuItems?.filter((item, index) => {
        return item.value === singlePatientData?.data?.type;
      });

      let notes = [
        {
          notes: "",
        },
      ];
      if (singlePatientData?.data?.notes?.length > 0) {
        notes = singlePatientData?.data?.notes?.map((value) => {
          return {
            id: value.id,
            notes: value.notes,
            created_at: value.created_at,
            created_by: value.created_by,
          };
        });
      }
      if (notes[0].notes !== "") {
        setNotesArray(notes);
      }
      setPatientData({
        name: singlePatientData?.data?.name || "",
        middle_name: singlePatientData?.data?.middle_name || "",
        last_name: singlePatientData?.data?.last_name || "",
        dob: singlePatientData?.data?.dob || "",
        notes: notes,
        surgery_id: singlePatientData?.data?.surgery?.id || "",
        surgery_info: singlePatientData?.data?.surgery,
        pharmacy_id: singlePatientData?.data?.pharmacy?.id || "",
        pharmacy_info: singlePatientData?.data?.pharmacy,
        address: singlePatientData?.data?.address || "",
        status: patientStatus[0]?.value,
        type: patientType[0]?.value,
        group_id: singlePatientData?.data?.g_id || "",
        group_info: {
          g_id: singlePatientData?.data?.g_id,
          g_name: singlePatientData?.data?.g_name,
        },
        is_urgent: singlePatientData?.data?.is_urgent,
        installment_dispensing:
          singlePatientData?.data?.instalment_type || "weekly",
        compliance_aid: singlePatientData?.data?.compliance_aid,
        g_color_code: "#000000",
        phn_number: singlePatientData?.data?.phone || "",
        nhs_number: singlePatientData?.data?.nhs_number || "",
      });
      if (singlePatientData?.data?.compliance_aid === true) {
        setSelected(true);
      }
      if (singlePatientData?.data?.instalment_type) {
        setInstallmentType(true);
      }
      const medications =
        singlePatientData?.data?.drugs?.map((item) => {
          return {
            ...item,
            errors: {
              name: "",
              quantity: "",
            },
          };
        }) || [];

      if (medications.length === 0) {
        handleClickAddDrug();
      } else {
        /**filter duplicate drugs */
        const uniqueMeditation = medications.reduce((accumulator, current) => {
          if (!accumulator.find((item) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        }, []);
        setMedications(uniqueMeditation);
      }
    }
  }, [singlePatientData?.data]);

  /** handle change action  */
  const handleChangeAction = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      changeable_prn: !allDrug[index]?.changeable_prn,
    };
    setMedications([...allDrug]);
  };
  const handlePharmacyDailog = () => {
    setAddPharmacy(true);
  };
  const handleSurgeryDailog = () => {
    setSurgeryRecordActionType("patientInfo");
    setIsOpenSurgeryModel(true);
  };
  const handleGroupDailog = () => {
    setIsOpenGroupModel(true);
  };

  /** Api call for Add Pharmacy, and Group Dailog */
  const getList = () => {
    let payLoad = {
      offset: 0,
      limit: 20,
    };
    let GroupPayLoad = {
      offset: 0,
      limit: 20,
    };
    if (selectedHeaderPharmacyId && selectedHeaderPharmacyId !== "all") {
      GroupPayLoad.pharmacy_id = [selectedHeaderPharmacyId];
    }
    getPharmaciesListAction(payLoad);
    getSGroupListAction(GroupPayLoad);
  };

  /** Calling Api to get pharmacies and Groups on page load for Add Pharmacy Dailog */
  useEffect(() => {
    getList();
  }, []);

  /** handle call back on submit info */
  const callBackOnSubmitPharmacyInfo = (pharmaInfo) => {
    const data = pharmaInfo.data;
    const { address, id, name, email } = data;
    setFieldValue("pharmacy_info", {
      id,
      address,
      name,
      email,
    });
    setFieldValue("pharmacy_id", id);
  };

  /** handle call back on submit info */
  const callBackOnSubmitGroupInfo = (patientInfo) => {
    const data = patientInfo.data;
    const { g_color_code, g_id, g_name } = data;
    setFieldValue("group_info", {
      g_id,
      g_color_code,
      g_name,
    });
    setFieldValue("group_id", g_id);
  };

  const handleColourTagAdd = () => {
    if (values?.tags_title) {
      if (values.g_color_code === "") {
        setErrors({
          g_color_code: "Color code is required.",
        });
        return;
      }
      if (tags && tags.length > 0) {
        const match = tags.some(
          (tag) =>
            tag.title.replace(/\s+/g, "") ===
            values.tags_title.replace(/\s+/g, "")
        );
        if (match) {
          setErrors({
            tags_title: "The title must be unique and cannot be duplicated.",
          });
          return;
        }
      }
      if (pageAccessMode === "edit") {
        setTags((prevTags) => [
          ...prevTags,
          {
            id:
              prevTags.length &&
              typeof prevTags[prevTags.length - 1].id === "number"
                ? prevTags[prevTags.length - 1].id + 1
                : 1,
            colour: values?.g_color_code,
            title: values?.tags_title,
          },
        ]);
      } else {
        setTags((prevTags) => [
          ...prevTags,
          {
            id: prevTags.length ? prevTags[prevTags.length - 1].id + 1 : 1,
            colour: values?.g_color_code,
            title: values?.tags_title,
          },
        ]);
      }
    }
    setFieldValue("tags_title", "");
    setFieldValue("g_color_code", "#000000");
  };

  const handleColourTagRemove = (id) => {
    if (pageAccessMode === "edit") {
      let tempArr = [...deleteTags];
      let tag = tags.find((tag) => tag.id === id && typeof tag.id !== "number");
      if (tag) {
        tempArr.push(tag.id);
        setDeleteTags(tempArr);
      }
    }
    setTags((prevTags) => prevTags.filter((tag) => tag.id !== id));
  };

  const handleClickAway = () => {
    setShowColorPalette(false);
  };

  /** handle get drug data */
  useLayoutEffect(() => {
    let params = {
      offset: 0,
      q: "",
    };
    getDrugFieldListAction(params);
  }, []);
  return (
    <Grid
      className={
        dialog
          ? classes.managePageHDialog
          : height < 930
          ? classes.managePageSmall
          : classes.managePageH
      }
    >
      {pageAccessMode === "edit" && singlePatientData.loading ? (
        <Grid display={"flex"} height="100px" justifyContent={"center"}>
          <CircularProgress />
        </Grid>
      ) : (
        <form
          // className={}
          name="registration"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();

            var name = document?.registration?.name?.value;
            var last_name = document?.registration?.last_name?.value;
            const firstError = Object.keys(errors).reduce((field, a) => {
              return !!errors[field] ? field : a;
            }, null);
            if (name === null || name === "" || name === undefined) {
              document.getElementById("name")?.focus();
            } else if (last_name === null || last_name === "") {
              document.getElementById("last_name")?.focus();
            } else if (firstError === "last_name") {
              document.getElementById("last_name")?.focus();
            } else if (firstError === "dob") {
              // setIsOpenDate(true);
              // || returnServerError("dob")
              document.getElementById("dob")?.focus();
            } else if (firstError === "surgery_id") {
              setIsOpenSurgeyAutocomplete(true);
              document.getElementById("surgery_info")?.focus();
            } else if (firstError === "pharmacy_id") {
              document.getElementById("pharmacy_info")?.focus();
            } else if (firstError === "address") {
              document.getElementById("address")?.focus();
            } else if (firstError === "phn_number") {
              document.getElementById("phn_number")?.focus();
            }
            if (returnServerError("dob").message !== "") {
              document.getElementById("dob")?.focus();
            }
            setTimeout(() => {
              const errorId = ["name", "quantity"];
              let foundError = false;
              const tableElement = document.getElementById("quantity");
              for (let i = 0; i <= medications.length; i++) {
                if (foundError) {
                  break;
                }
                for (let j = 0; j <= errorId.length; j++) {
                  const element = document.getElementById(`${errorId[j]}_${i}`);

                  if (
                    element?.parentElement?.nextSibling?.classList?.contains(
                      "Mui-error"
                    )
                  ) {
                    tableElement.scrollIntoView();

                    setTimeout(() => {
                      element.focus();
                    }, 50);
                    foundError = true;
                    break;
                  }
                }
              }
            }, 1000);
          }}
        >
          <Grid
            className={
              dialog ? classes.mainContainerDailog : classes.mainContainer
            }
          >
            {/*       General Information            */}

            <Grid
              className={
                dialog
                  ? classes.generalInfoContainerDailog
                  : height < 925
                  ? classes.generalInfoContainerSmall
                  : classes.generalInfoContainer
              }
              // className={classes.rsPatientPaperGeneralInfoMedi}
            >
              <Paper
                elevation={1}
                className={classes.rsPatientPaperGeneralInfo}
                // className={classes.rsPatientPaperGeneralInfoMedi}
                // sx={{ overflowY: "auto", maxHeight: "40%" }}
              >
                <Grid
                  container
                  columnSpacing={2.5}
                  rowSpacing={1.5}
                  className={
                    dialog
                      ? classes.rsPatientGridOneDialog
                      : classes.rsPatientGridOne
                  }
                  id={"error"}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="h3"
                      medium
                      color="Black"
                      fontSize="18px"
                    >
                      General Information
                    </Typography>
                    <Grid item xs={12} className={classes.titleMain}>
                      <Divider />
                    </Grid>
                  </Grid>

                  <Grid item xs={12} className={classes.inputGrid}>
                    <Grid xs={12}>
                      <TextField
                        id="name"
                        variant="outlined"
                        fullWidth
                        placeholder="First Name *"
                        label="First Name *"
                        size="small"
                        name="name"
                        value={values?.name}
                        error={touched?.name && errors?.name}
                        helperText={touched?.name && errors?.name}
                        onChange={(e) => {
                          handleChange(e);
                          returnServerError("");
                        }}
                        onBlur={handleBlur}
                      />
                    </Grid>
                    {/* <Grid xs={12} sm={6} md={6} lg={4}>
                    <TextField
                      id="middle_name"
                      variant="outlined"
                      fullWidth
                      // placeholder="Middle Name (Optional)"
                      // label="Middle Name (Optional)"
                      placeholder="Middle Name"
                      label="Middle Name"
                      size="small"
                      name="middle_name"
                      value={values?.middle_name}
                      error={touched?.middle_name && errors?.middle_name}
                      helperText={touched?.middle_name && errors?.middle_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Grid> */}

                    <Grid ml={1} xs={12}>
                      <TextField
                        id="last_name"
                        variant="outlined"
                        fullWidth
                        placeholder="Last Name *"
                        label="Last Name *"
                        size="small"
                        name="last_name"
                        value={values?.last_name}
                        error={touched?.last_name && errors?.last_name}
                        helperText={touched?.last_name && errors?.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.inputGrid}>
                    <Grid item xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          disableFuture
                          label="Date of birth"
                          views={["year", "month", "day"]}
                          inputFormat="DD-MM-YYYY"
                          value={values?.dob ? values?.dob : "" || null}
                          onFocus={() => setIsOpenDate(true)}
                          open={() => setIsOpenDate(true)}
                          onClose={() => {
                            setIsOpenDate(false);
                          }}
                          onChange={(newDate) => {
                            setFieldValue("dob", newDate);
                            returnServerError("");
                          }}
                          renderInput={(params) => (
                            <TextField
                              id="dob"
                              fullWidth
                              size="small"
                              inputFormat="DD-MM-YYYY"
                              name="dob"
                              {...params}
                              error={
                                (touched?.dob && errors?.dob) ||
                                returnServerError("dob").keyPresent
                              }
                              helperText={
                                (touched?.dob && errors?.dob) ||
                                returnServerError("dob").message
                              }
                              onBlur={handleBlur}
                            />
                          )}
                          name="dob"
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid xs={12}>
                      <TextField
                        className={classes.rsRootTextField}
                        variant="outlined"
                        fullWidth
                        placeholder="Address (Optional)"
                        label="Address (Optional)"
                        size="small"
                        id="address"
                        name="address"
                        value={values?.address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    className={classes.inputGridResponsive}
                  >
                    {loginUserDetail?.loginUserDetail?.data?.data
                      ?.is_new_user === false && (
                      <Grid
                        xs={12}
                        // style={{ marginBottom: "10px" }}
                        marginRight={"18px"}
                      >
                        <PharmacyAutoComplete
                          fullWidth
                          name="pharmacy_info"
                          id="pharmacy_info"
                          className={classes.autoCompleteBox}
                          value={values?.pharmacy_info}
                          onChange={(e, value) => {
                            setFieldValue("pharmacy_info", value);
                            setFieldValue("pharmacy_id", value?.id);
                          }}
                          buttonOptionTop={
                            showDataBasedOnRole !== "nursing" ? true : false
                          }
                          buttonTitle={"Add New Pharmacy"}
                          handleButtonClick={handlePharmacyDailog}
                          isOpenPharmacyAutocomplete={
                            isOpenPharmacyAutocomplete
                          }
                          setIsOpenPharmacyAutocomplete={
                            setIsOpenPharmacyAutocomplete
                          }
                          PharmacyRef={PharmacyRef}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              inputRef={PharmacyRef}
                              {...params}
                              label="Pharmacy *"
                              name="pharmacy_info"
                              id="pharmacy_info"
                              error={
                                (touched?.pharmacy_info ||
                                  touched?.pharmacy_id) &&
                                errors.pharmacy_id
                              }
                              helperText={
                                (touched?.pharmacy_info ||
                                  touched?.pharmacy_id) &&
                                errors.pharmacy_id
                              }
                            />
                          )}
                        />
                      </Grid>
                    )}
                    <Grid xs={12}>
                      <SurgryAutoComplete
                        fullWidth
                        // multiple
                        name="surgery_info"
                        id="surgery_info"
                        isOpenSurgeyAutocomplete={isOpenSurgeyAutocomplete}
                        setIsOpenSurgeyAutocomplete={
                          setIsOpenSurgeyAutocomplete
                        }
                        className={classes.autoCompleteBox}
                        value={values?.surgery_info}
                        onChange={(e, value) => {
                          setFieldValue("surgery_info", value);
                          setFieldValue("surgery_id", value?.id);
                          // if (pageAccessMode === "create") {
                          //   setIsOpenPharmacyAutocomplete(true);
                          //   getPharmacyListAction({
                          //     offset: 0,
                          //     ...(values?.pharmacy_info?.name && {
                          //       q: values?.pharmacy_info?.name,
                          //     }),
                          //   });
                          // }
                        }}
                        buttonOptionTop={
                          showDataBasedOnRole !== "nursing" ? true : false
                        }
                        buttonTitle={"Add New Surgery"}
                        handleButtonClick={handleSurgeryDailog}
                        SurgeryRef={SurgeryRef}
                        onBlur={handleBlur}
                        renderInput={(params) => (
                          <TextField
                            inputRef={SurgeryRef}
                            {...params}
                            label="Surgery *"
                            name="surgery_info"
                            id="surgery_info"
                            error={
                              (touched?.surgery_info || touched?.surgery_id) &&
                              errors.surgery_id
                            }
                            helperText={
                              (touched?.surgery_info || touched?.surgery_id) &&
                              errors.surgery_id
                            }
                            onBlur={handleBlur}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    className={classes.inputGridResponsive}
                  >
                    <Grid
                      xs={12}
                      // sm={6}
                      // md={6}
                      // lg={4}
                      marginRight={
                        showDataBasedOnRole !== "nursing" ? "18px" : "0px"
                      }
                      className={classes.surgeryAutocompleteGrid}
                    >
                      <AutoCompleteTextField
                        open={isOpenStatusList}
                        onOpen={() => {
                          setIsOpenStatusList(true);
                        }}
                        onClose={() => {
                          setIsOpenStatusList(false);
                        }}
                        options={statusMenuItems}
                        inputValue={selectedRoleOption()}
                        getOptionLabel={(option) => option.label}
                        filterOptions={(option) => {
                          let result = [...option];
                          return result || [];
                        }}
                        onChange={(e, value) => {
                          setIsOpenStatusList(false);
                          setFieldValue("status", value?.value || "");
                          handleChange("status", value?.value || "");
                        }}
                        placeholder="Status *"
                        label="Status *"
                        error={touched?.status && errors?.status}
                        helperText={touched?.status && errors?.status}
                        onBlur={handleBlur}
                      />
                    </Grid>
                    {showDataBasedOnRole !== "nursing" && (
                      <Grid xs={12}>
                        <GroupAutoComplete
                          fullWidth
                          className={classes.groupAutoCompleteBox}
                          value={values?.group_info}
                          onChange={(e, value) => {
                            setFieldValue("group_info", value);
                            setFieldValue("group_id", value?.g_id);
                          }}
                          dialog={dialog}
                          buttonOptionTop={true}
                          buttonTitle={"Add New Patient Group"}
                          handleButtonClick={handleGroupDailog}
                          onBlur={handleBlur}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Patient Group (Optional)"
                              error={touched?.group_id && errors?.group_id}
                              helperText={touched?.group_id && errors?.group_id}
                            />
                          )}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    className={classes.inputGridResponsive}
                  >
                    <Grid xs={12} marginRight={"18px"}>
                      <TextField
                        id="phn_number"
                        variant="outlined"
                        fullWidth
                        placeholder="Phone Number (Optional)"
                        label="Phone Number (Optional)"
                        size="small"
                        name="phn_number"
                        value={values?.phn_number}
                        error={touched?.phn_number && errors?.phn_number}
                        helperText={touched?.phn_number && errors?.phn_number}
                        onChange={(e) => {
                          handleChange(e);
                          returnServerError("");
                        }}
                        onBlur={handleBlur}
                      />
                    </Grid>
                    <Grid xs={12}>
                      <TextField
                        id="nhs_number"
                        variant="outlined"
                        fullWidth
                        placeholder="NHS No. (Optional)"
                        label="NHS No. (Optional)"
                        size="small"
                        name="nhs_number"
                        value={values?.nhs_number}
                        error={touched?.nhs_number && errors?.nhs_number}
                        helperText={touched?.nhs_number && errors?.nhs_number}
                        onChange={(e) => {
                          handleChange(e);
                          returnServerError("");
                        }}
                        onBlur={handleBlur}
                      />
                    </Grid>
                  </Grid>

                  {/* {loginUserDetail?.loginUserDetail?.data?.data?.is_new_user ===
                    true && (
                    <Grid
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                      className={classes.textFilledAlign}
                      // style={{ marginBottom: "10px" }}
                    >   </Grid>
                  )} */}

                  {/* <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    className={clsx(classes.title, classes.resPatientTypeGrid)}
                  >
                    <Grid
                      container
                      xs={6}
                      sm={6}
                      md={6}
                      display={"flex"}
                      alignItems={"flex-start"}
                      justifyContent={"flex-start"}
                      flexDirection={"column"}
                      padding={"10px"}
                    >
                      <Typography className={classes.title}>
                        Patient Type (Optional)
                      </Typography>

                      <RadioGroup
                        aria-labelledby="patient-type-radio-buttons-group-label"
                        name="patient-type-radio-buttons-group"
                      >
                        <Grid className={classes.radioGroup}>
                          {PatientType?.map((item, index) => {
                            return (
                              <FormControlLabel
                                error={touched?.type && errors?.type}
                                helperText={touched?.type && errors?.type}
                                value={item}
                                key={index}
                                onChange={(e) => {
                                  if (item.type === values.type) {
                                    setFieldValue("type", "");
                                    handleChange("type", "");
                                  }
                                  if (
                                    item.type === "" ||
                                    item.type !== values.type
                                  ) {
                                    setIsOpenPatientTypeList(false);
                                    setFieldValue("type", item?.type || "");
                                    handleChange("type", item?.type || "");
                                  }
                                }}
                                label={item.item}
                                control={
                                  <Radio checked={values?.type == item.type} />
                                  // <Chip
                                  //   icon={item?.icon}
                                  //   checked={values?.type == item.type}
                                  //   className={clsx(
                                  //     item.type === "collection"
                                  //       ? classes.chipMainCollection
                                  //       : classes.chipMain,
                                  //     item.type === "collection"
                                  //       ? classes.iconStyle
                                  //       : classes.iconCollection,
                                  //     values?.type == item.type
                                  //       ? item.type === "collection"
                                  //         ? classes.chipsFilledNotCollect
                                  //         : classes.chipsFilledNot
                                  //       : item.type !== "collection"
                                  //       ? classes.chips
                                  //       : classes.chipsNotCollect
                                  //   )}
                                  //   label={
                                  //     <div>
                                  //       {item.item}
                                  //       {values?.type == item.type ? (
                                  //         <CheckCircleOutlineOutlinedIcon />
                                  //       ) : (
                                  //         <></>
                                  //       )}
                                  //     </div>
                                  //   }
                                  //   color={
                                  //     values?.type == item.type
                                  //       ? "primary"
                                  //       : "default"
                                  //   }
                                  //   variant={"outlined"}
                                  // />
                                }
                              />
                            );
                          })}{" "}
                        </Grid>
                      </RadioGroup>
                      <FormGroup>
                        <FormControlLabel
                          className={classes.checkboxLabel}
                          label={"Compliance aid"}
                          control={
                            <Checkbox
                              color="primary"
                              checked={values?.compliance_aid}
                              onChange={(e, value) => {
                                setFieldValue(
                                  "compliance_aid",
                                  !values?.compliance_aid
                                );
                                setSelected((s) => !s);
                              }}
                            />
                          }
                        />
                      </FormGroup>
                    </Grid>

                    <Grid
                      xs={8}
                      sm={8}
                      md={8}
                      container
                      padding={"10px"}
                      display={"flex"}
                      flexDirection={"column"}
                    >
                      <FormGroup>
                        <FormControlLabel
                          className={clsx(
                            classes.formLabel,
                            classes.installMentFormLabel
                          )}
                          control={
                            <Checkbox
                              color="primary"
                              checked={installmentType}
                              onChange={() => {
                                setInstallmentType(!installmentType);
                              }}
                            />
                          }
                          label="Installment dispensing"
                        />
                      </FormGroup>
                      <RadioGroup
                        aria-labelledby="radio-buttons-group-label"
                        name="radio-buttons-group"
                        className={classes.radioGroup}
                      >
                        {installmentType && (
                          <>
                            <Typography className={classes.title}>
                              Dispensing Type
                            </Typography>
                            <Grid
                              container
                              className={classes.radioGroup}
                              flexDirection={"column"}
                              alignItems={"flex-start"}
                            >
                              <div>
                                {InstallmentTypes.slice(0, 3).map(
                                  (item, index) => (
                                    <FormControlLabel
                                      error={
                                        touched?.installment_dispensing &&
                                        errors?.installment_dispensing
                                      }
                                      helperText={
                                        touched?.installment_dispensing &&
                                        errors?.installment_dispensing
                                      }
                                      className={`${classes.labelWhiteSpaceNW} customClassFirstRow`}
                                      value={item}
                                      key={index}
                                      label={item?.item}
                                      onChange={() => {
                                        setInstallmentDispensingList(false);
                                        setFieldValue(
                                          "installment_dispensing",
                                          item?.type || ""
                                        );
                                        handleChange(
                                          "installment_dispensing",
                                          item?.type || ""
                                        );
                                      }}
                                      control={
                                        <Radio
                                          checked={
                                            values?.installment_dispensing ==
                                            item.type
                                          }
                                        />
                                      }
                                    />
                                  )
                                )}
                              </div>
                              <div>
                                {InstallmentTypes.slice(3).map((item, index) => (
                                  <FormControlLabel
                                    error={
                                      touched?.installment_dispensing &&
                                      errors?.installment_dispensing
                                    }
                                    helperText={
                                      touched?.installment_dispensing &&
                                      errors?.installment_dispensing
                                    }
                                    className={`${classes.labelWhiteSpaceNW} customClassSecondRow`}
                                    value={item}
                                    key={index + 3}
                                    label={item?.item}
                                    onChange={() => {
                                      setInstallmentDispensingList(false);
                                      setFieldValue(
                                        "installment_dispensing",
                                        item?.type || ""
                                      );
                                      handleChange(
                                        "installment_dispensing",
                                        item?.type || ""
                                      );
                                    }}
                                    control={
                                      <Radio
                                        checked={
                                          values?.installment_dispensing ==
                                          item.type
                                        }
                                      />
                                    }
                                  />
                                ))}
                              </div>
                            </Grid>
                          </>
                        )}
                      </RadioGroup>
                    </Grid>
                  </Grid> */}
                </Grid>
              </Paper>

              <Grid
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                {/*       Create Tags           */}
                <Paper
                  elevation={1}
                  className={
                    dialog
                      ? classes.rsTagDialog
                      : height < 925
                      ? classes.rsPatientPaperTagSmall
                      : classes.rsPatientPaperTag
                  }
                >
                  <Grid container xs={12}>
                    <Grid
                      item
                      xs={12}
                      className={
                        dialog
                          ? classes.rsPatientGridOneDialog
                          : classes.rsPatientGridOne
                      }
                    >
                      <Grid
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"flex-start"}
                        justifyContent={"space-between"}
                      >
                        <Typography medium color="Black" variant="h3">
                          {/* Create Tags */}
                          Add Tags
                        </Typography>
                        {pageAccessMode === "create" ||
                        (pageAccessMode !== "create" && tags.length >= 1) ? (
                          <Grid display={"flex"} justifyContent={"flex-end"}>
                            <Button
                              className={classes.rsTagBtn}
                              variant="contained"
                              style={{ padding: "0px !important" }}
                              startIcon={
                                <PrimaryIcon
                                  icon={AddIcon}
                                  color="white"
                                  width="16px"
                                  height="16px"
                                />
                              }
                              onClick={() => setOpenTagDialog(true)}
                            >
                              Create Tag
                            </Button>
                          </Grid>
                        ) : null}
                      </Grid>
                      <Grid className={classes.titleMain}>
                        <Divider />
                      </Grid>
                    </Grid>
                    {/* <Grid xs={12} className={classes.createTagsContainer}>
                    {tags.length >= 1 && (
                      <>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={6}
                          // className={classes.textFilledAlign}
                        >
                          <TextField
                            id="tags_title"
                            variant="outlined"
                            fullWidth
                            placeholder="Tags title*"
                            label="Tags title*"
                            size="small"
                            name="tags_title"
                            value={values?.tags_title}
                            error={touched?.tags_title && errors?.tags_title}
                            helperText={
                              touched?.tags_title && errors?.tags_title
                            }
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                          />
                        </Grid>

                        <ClickAwayListener onClickAway={handleClickAway}>
                          <Grid
                            item
                            xs={12}
                            sm={6}
                            md={6}
                            lg={6}
                            className={classes.colorField}
                          >
                            <TextField
                              variant="outlined"
                              fullWidth
                              placeholder="Colour Code*"
                              label="Colour Code *"
                              size="small"
                              name="g_color_code"
                              value={values?.g_color_code}
                              error={
                                touched?.g_color_code && errors?.g_color_code
                              }
                              helperText={
                                touched?.g_color_code && errors?.g_color_code
                              }
                              ref={anchorRef}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              onClick={() => {
                                setShowColorPalette(!showColorPalette);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Card
                                      className={classes.groupColorIcon}
                                      style={{
                                        background: values?.g_color_code,
                                      }}
                                    />
                                  </InputAdornment>
                                ),
                                endAdornment: (
                                  <InputAdornment
                                    position="end"
                                    // ref={anchorRef}
                                  >
                                    <ColorLensIcon
                                      onClick={() =>
                                        setShowColorPalette(!showColorPalette)
                                      }
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                            {showColorPalette && (
                              <Popper
                                open={showColorPalette}
                                anchorEl={anchorRef.current}
                                placement={
                                  screenWidth < 500 ? "bottom" : "left"
                                }
                                // placement={"bottom"}
                                className={classes.mainPopper}
                                // placement="bottom-start"
                              >
                                <Card
                                  // ref={colorPaletteRef}
                                  className={classes.colorPalette}
                                >
                                  <ChromePicker
                                    color={values?.g_color_code}
                                    onChange={(e) => {
                                      setFieldValue("g_color_code", e.hex);
                                    }}
                                    disableAlpha={true}
                                  />
                                </Card>
                              </Popper>

                              // <Stack
                              //   // className={
                              //   //   groupRecordActionType == "createNewGroup"
                              //   //     ? classes.colorPaletteadd
                              //   //     : classes.colorPalette
                              //   // }
                              //   className={classes.colorPalette}
                              //   // style={{
                              //   //   top:
                              //   //     groupRecordActionType !== "editGroupDetail"
                              //   //       ? "38%"
                              //   //       : "32%",
                              //   // }}
                              // >
                              //   <Card ref={colorPaletteRef}>
                              //     <ChromePicker
                              //       dark
                              //       disableAlpha={true}
                              //       width={220}
                              //       height={100}
                              //       color={values?.g_color_code}
                              //       onChange={(e) => {
                              //         setFieldValue("g_color_code", e.hex);
                              //       }}
                              //     />
                              //   </Card>
                              // </Stack>
                            )}
                          </Grid>
                        </ClickAwayListener>
                      </>
                    )}
                  </Grid> */}
                    <Grid
                      container
                      className={
                        dialog
                          ? classes.tagsContainerDailog
                          : classes.tagsContainer
                      }
                    >
                      {pageAccessMode !== "create" && tags.length < 1 && (
                        <Grid
                          alignItems={"center"}
                          width={"-webkit-fill-available"}
                        >
                          <Grid display={"flex"} justifyContent={"center"}>
                            <Button
                              className={classes.rsTagBtn}
                              variant="contained"
                              style={{
                                padding: "0px !important",
                                marginTop: "15px",
                                marginBottom: "15px",
                              }}
                              startIcon={
                                <PrimaryIcon
                                  icon={AddIcon}
                                  color="white"
                                  width="16px"
                                  height="16px"
                                />
                              }
                              onClick={() => {
                                setOpenTagDialog(true);
                              }}
                            >
                              Create Tag
                            </Button>
                          </Grid>

                          {tags.length === 0 && (
                            <Typography
                              variant="h6"
                              medium
                              color="grey"
                              style={{
                                textAlign: "center",
                                fontSize: "10px !important",
                                fontWeight: "400",
                              }}
                            >
                              Click "Create Tag" to create a new tag.
                            </Typography>
                          )}
                        </Grid>
                      )}
                      {pageAccessMode === "create" && (
                        <>
                          <Tooltip
                            title={
                              defaultTags.delivery
                                ? ""
                                : "Click To Activate Delivery tag"
                            }
                          >
                            <div
                              className={classes.defaultTag}
                              style={{
                                background: defaultTags.delivery
                                  ? `#4644C0`
                                  : `#a6a5ff`,
                              }}
                              onClick={() => {
                                setDefaultTags((prev) => ({
                                  ...prev,
                                  delivery: !defaultTags.delivery,
                                }));
                              }}
                            >
                              <p>Delivery</p>
                            </div>
                          </Tooltip>

                          <Tooltip
                            title={
                              defaultTags.collection
                                ? ""
                                : "Click To Activate Collection tag"
                            }
                          >
                            <div
                              className={classes.defaultTag}
                              style={{
                                background: defaultTags.collection
                                  ? `#FFB82F`
                                  : // : `#f2d294`,
                                    `#e6c98f`,
                              }}
                              onClick={() => {
                                setDefaultTags((prev) => ({
                                  ...prev,
                                  collection: !defaultTags.collection,
                                }));
                              }}
                            >
                              <p>Collection</p>
                            </div>
                          </Tooltip>

                          <Tooltip
                            title={
                              defaultTags.compliance_aid
                                ? ""
                                : "Click To Activate Compliance aid tag"
                            }
                          >
                            <div
                              className={classes.defaultTag}
                              style={{
                                background: defaultTags.compliance_aid
                                  ? `#6B8535`
                                  : `#aebc8e`,
                              }}
                              onClick={() => {
                                setDefaultTags((prev) => ({
                                  ...prev,
                                  compliance_aid: !defaultTags.compliance_aid,
                                }));
                              }}
                            >
                              <p>Compliance aid</p>
                            </div>
                          </Tooltip>
                        </>
                      )}

                      {tags?.map((tag) => {
                        return (
                          <div
                            item
                            className={classes.tag}
                            style={{ background: `${tag.colour}` }}
                          >
                            <p>{tag.title}</p>
                            <IconButton
                              onClick={() => handleColourTagRemove(tag.id)}
                            >
                              <PrimaryIcon
                                height="10px"
                                width="12px"
                                icon={CloseIcon}
                                color="white"
                              />
                            </IconButton>
                          </div>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Paper>
                {/* <Grid className={classes.rsPatientMedicationBtn}>
            </Grid> */}
                <Paper
                  elevation={1}
                  container
                  className={
                    dialog
                      ? classes.rsPatientPaperAddNoteDialog
                      : height < 925
                      ? classes.rsPatientPaperAddNoteSmall
                      : classes.rsPatientPaperAddNote
                  }
                >
                  <Grid
                    container
                    // columnSpacing={2.5}
                    // rowSpacing={3}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      display={"flex"}
                      flexDirection={"column"}
                      className={
                        dialog
                          ? classes.rsPatientGridOneDialog
                          : classes.rsPatientGridOne
                      }
                    >
                      <Grid display={"flex"} justifyContent={"space-between"}>
                        <Typography variant="h3" medium color="secondary">
                          Patient Notes
                        </Typography>

                        {notesArray.length >= 1 && (
                          <Button
                            variant="outlined"
                            className={classes.rsPatientAddNoteBtn}
                            borderRadius={"8px !important"}
                            // disabled={blankNotes.length > 0}
                            startIcon={<AddRoundedIcon color="primary" />}
                            onClick={() => {
                              setOpenNotesDailog(true);
                              setNotesEdit(false);
                            }}
                          >
                            Add Note
                          </Button>
                        )}
                      </Grid>
                      <Grid className={classes.titleMain}>
                        <Divider />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      className={
                        dialog
                          ? classes.noteContainerDailog
                          : classes.noteContainer
                      }
                    >
                      {notesArray?.map((item, index) => {
                        return (
                          <>
                            {/* <Box sx={{ width: 110, height: 102 }} container> */}
                            <HtmlTooltipMain
                              title={
                                <>
                                  <div>
                                    {item?.notes && <p>Note : {item?.notes}</p>}
                                    <p className={classes.toolTip}>
                                      By{" "}
                                      {item?.created_by
                                        ? item?.created_by
                                        : "Admin"}{" "}
                                      at &nbsp;
                                      {moment(item?.created_at).fromNow()}
                                    </p>
                                  </div>
                                </>
                              }
                            >
                              <Box
                                item
                                sx={{
                                  // width: 90,
                                  // height: 85,
                                  marginTop: "10px",
                                  marginLeft: "10px",
                                }}
                                container
                              >
                                <Card
                                  className={classes.card}
                                  variant="outlined"
                                  // sx={{ width: 110, height: 102 }}
                                  sx={{ width: "auto", height: 36 }}
                                >
                                  <CardHeader
                                    sx={{ p: 0 }}
                                    action={
                                      <HtmlTooltipMain title="">
                                        <IconButton
                                          className={classes.iconBtn}
                                          onClick={(e) => {
                                            setRemoveIndex(index);
                                            setOpenConfirm(true);
                                            // handleClickRemoveNote(index)
                                          }}
                                        >
                                          <PrimaryIcon
                                            color="#5A6872"
                                            width="12px"
                                            height="12px"
                                            icon={ThickCross}
                                            cursor="pointer"
                                          />
                                        </IconButton>
                                      </HtmlTooltipMain>
                                    }
                                  />
                                  <CardContent
                                    sx={{ p: 0 }}
                                    onClick={() => {
                                      setOpenNotesDailog(true);
                                      setNotesEdit(true);
                                      setNotesData({
                                        title: `Patient Notes (Note ${
                                          index + 1
                                        })`,
                                        index: index,
                                        data: item.notes,
                                      });
                                    }}
                                  >
                                    {/* <ComplianceIcon /> */}
                                    <div>{`Note ${index + 1}`}</div>
                                  </CardContent>
                                </Card>
                              </Box>
                            </HtmlTooltipMain>
                            {/* <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      key={index}
                      className={classes.notePadding}
                    >
                    <TextField
                        fullWidth
                        className={classes.textField}
                        variant="outlined"
                        size="small"
                        // placeholder="Add Note"
                        // label="Add Note"
                        placeholder="Add Note"
                        label="Note"
                        name={`notes[${index}]`}
                        id="outlined-adornment-weight"
                        aria-describedby="outlined-weight-helper-text"
                        value={item.notes}
                        onChange={(e) => {
                          handleChange(e);
                          handleNoteChange(e, index);
                        }}
                        error={touched?.notes && errors?.notes}
                        helperText={touched?.notes && errors?.notes}
                        onBlur={handleBlur}
                        inputProps={{
                          "aria-label": "weight",
                        }}
                        // InputProps={{
                        //   endAdornment: (
                        //     // notesArray?.length > 1 ? (
                        //     <InputAdornment
                        //       position="end"
                        //       cursor={InputAdornment}
                        //       onClick={(e) => handleClickRemoveNote(index)}
                        //     >
                        //       <PrimaryIcon
                        //         width="20px"
                        //         icon={CloseIcon}
                        //         color="white"
                        //       />
                        //     </InputAdornment>
                        //   ),
                        //   // ) : null,
                        // }}
                      />
                      <IconButton
                        cursor={"pointer"}
                        onClick={(e) => handleClickRemoveNote(index)}
                        className={classes.closeIcon}
                      >
                        <CloseRoundedIcon color="Black" />
                      </IconButton>
                    </Grid> */}
                          </>
                        );
                      })}
                      {notesArray.length < 1 && (
                        <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          width={"-webkit-fill-available"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          // height={"120px"}
                        >
                          <Button
                            variant="outlined"
                            className={clsx(
                              classes.rsPatientAddNoteBtn,
                              classes.noteBtn
                            )}
                            borderRadius={"8px !important"}
                            // marginBottom={"15px !important"}
                            // disabled={blankNotes.length > 0}
                            startIcon={
                              // <AddRoundedIcon color="primary" />
                              <PrimaryIcon
                                icon={AddIcon}
                                color="white"
                                width="16px"
                                height="16px"
                              />
                            }
                            onClick={() => {
                              setOpenNotesDailog(true);
                              setNotesEdit(false);
                            }}
                          >
                            Add Note
                          </Button>

                          {/* {notesArray.length <= 1 && ( */}
                          <Typography
                            variant="h6"
                            medium
                            color="grey"
                            style={{
                              // fontStyle: "italic",
                              fontWeight: "400",
                              // marginTop: "20px",
                              // marginTop: "59px",
                              position: "relative",
                              textAlign: "center",
                            }}
                          >
                            Click "Add Note" to create a new Note.
                          </Typography>
                          {/* )} */}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              {/*       Submit           */}

              {width > 1100 && (
                <Grid
                  className={
                    // Object.keys(errors).length === 5
                    height < 925 || width < 1650 || 1100 > width
                      ? classes.btnContainerSmall
                      : dialog
                      ? classes.btnContainerDailog
                      : classes.btnContainer
                  }
                >
                  <Box>
                    <Button
                      variant="outlined"
                      className={clsx("BtnGray", classes.rsPatientCancelBtn)}
                      onClick={() => {
                        if (typeof callBackOnCancel === "function") {
                          callBackOnCancel();
                        } else {
                          setLocalStorage('isPatientCancel', 'true');
                          navigate("/patients");
                          // let payload = {
                          //   offset: 0,
                          // };
                          // if (
                          //   selectedHeaderPharmacyId !== "" &&
                          //   selectedHeaderPharmacyId !== "all"
                          // ) {
                          //   payload.pharmacy_id = [selectedHeaderPharmacyId];
                          // }
                          // getPatientListAction(payload);
                        }
                      }}
                      // className={classes.rsPatientCancelBtn}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      type="submit"
                      className={classes.rsSubmittBtn}
                      disabled={
                        createPatientData?.loading ||
                        updatePatientData?.loading ||
                        singlePatientData.loading
                      }
                      startIcon={
                        (createPatientData?.loading ||
                          updatePatientData?.loading) && (
                          <CircularProgress color="white" size="20px" />
                        )
                      }
                    >
                      Submit
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>

            <Grid
              className={
                dialog
                  ? classes.medicineContainerDialog
                  : height > 925
                  ? classes.medicineContainer
                  : classes.medicineContainerSmall
              }
            >
              {/*       Medicine Details           */}

              <Paper
                elevation={1}
                className={classes.rsPatientPaperGeneralInfoMedi}
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    className={
                      dialog
                        ? classes.rsPatientGridOneDialog
                        : classes.rsPatientGridOne
                    }
                  >
                    <Grid
                      position={"sticky"}
                      display={"flex"}
                      justifyContent={"space-between"}
                      width={"-webkit-fill-available"}
                      xs={12}
                    >
                      <Typography variant="h3" medium color="secondary">
                        Medicine details
                      </Typography>
                      <Button
                        className={classes.rsPatientAddNoteBtn}
                        variant="contained"
                        disabled={blankMediation.length > 0}
                        startIcon={
                          <PrimaryIcon
                            icon={AddIcon}
                            color="white"
                            width="16px"
                            height="16px"
                          />
                        }
                        onClick={() => {
                          handleClickAddDrug();
                          setPatientInfoActionType("patientInfo");
                          setListOpen(true);
                          medicationRef?.current?.focus();
                        }}
                      >
                        Add Medicine
                      </Button>
                    </Grid>

                    <Grid item xs={12} className={classes.titleMain}>
                      <Divider />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} className={classes.rsMediValue}>
                    {medications?.map((item, index) => {
                      return (
                        <Grid
                          className={classes.tableBody}
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                        >
                          <Grid xs={12} sm={8} md={8} lg={9} xl={9}>
                            {/* {pageAccessMode !== "create" &&
                              item?.order_date !== null &&
                              item?.order_date !== undefined && (
                                <Box className={classes.LastOrderdate}>
                                  <Typography variant="h6">
                                    Last ordered:
                                  </Typography>
                                  <Typography variant="h5">
                                    {moment(item?.order_date).format(
                                      "DD-MM-YYYY"
                                    ) || "N / A"}
                                  </Typography>
                                </Box>
                              )} */}
                            {pageAccessMode !== "create" && (
                              <Box className={classes.LastOrderdate}>
                                <Typography variant="h6">
                                  Last ordered:
                                </Typography>
                                <Typography variant="h5">
                                  {/* {item?.order_date
                                      ? moment(new Date(item?.order_date)).format(
                                          "DD-MM-YYYY"
                                        ) || "N / A"
                                      : "-"} */}
                                  {item?.order_date !== null &&
                                  item?.order_date !== undefined
                                    ? moment(item?.order_date).format(
                                        "DD-MM-YYYY"
                                      ) || "N / A"
                                    : "-"}
                                </Typography>
                              </Box>
                            )}
                            <DrugAutoComplete
                              listOpen={listOpen}
                              fullWidth
                              filterMedication={medications}
                              className={
                                item?.order_date === null ||
                                item?.order_date === undefined
                                  ? classes.rsDrugAutoCompleteBox
                                  : classes.rsDrugAutoCompleteBoxEdit
                              }
                              value={item}
                              onChange={(e, value) => {
                                value = value
                                  ? {
                                      ...value,
                                      name: value?.label,
                                    }
                                  : value;
                                delete value?.label;
                                handleDrugChange(e, index, value);
                                handleChange("drug", value);
                                if (value !== null) {
                                  quantityRef.current.focus();
                                }
                              }}
                              id={`name_${index}`}
                              patientInfoActionType={patientInfoActionType}
                              excludeDrugs={medicationId}
                              renderInput={(params) => (
                                <>
                                  <TextField
                                    inputRef={
                                      patientInfoActionType === "patientInfo"
                                        ? medicationRef
                                        : ""
                                    }
                                    id={`name_${index}`}
                                    autoFocus={
                                      patientInfoActionType === "patientInfo"
                                    }
                                    {...params}
                                    label="Drug Name"
                                    placeholder="Choose Drug"
                                    error={
                                      item?.errors?.name && item?.errors?.name
                                    }
                                    helperText={
                                      item?.errors?.name && item?.errors?.name
                                    }
                                    onBlur={handleBlur}
                                  />
                                </>
                              )}
                            />
                          </Grid>

                          <Grid
                            xs={12}
                            sm={5}
                            md={5}
                            lg={4}
                            xl={4}
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            className={
                              item?.order_date !== null &&
                              item?.order_date !== undefined &&
                              classes.rsQtyContainer
                            }
                          >
                            {/* <Grid display={"flex"} alignItems={"center"}> */}
                            <Grid
                              xs={3}
                              sm={3}
                              md={3}
                              lg={dialog ? 3.5 : width < 1600 ? 3.5 : 2.5}
                              xl={dialog ? 3.5 : 2.5}
                              className={
                                item?.order_date === null ||
                                item?.order_date === undefined
                                  ? classes.quantity
                                  : classes.quantityEdit
                              }
                            >
                              <TextField
                                variant="outlined"
                                // label="Quantity"
                                // placeholder="Quantity"
                                placeholder="Qty"
                                size="small"
                                // type="number"
                                inputProps={{ maxLength: 50 }}
                                name={`medications[${index}]`}
                                value={item?.quantity}
                                inputRef={quantityRef}
                                error={
                                  item?.errors?.quantity &&
                                  item?.errors?.quantity
                                }
                                helperText={
                                  item?.errors?.quantity &&
                                  item?.errors?.quantity
                                }
                                id={`quantity_${index}`}
                                onChange={(e, value) => {
                                  handleChangeQuantity(e, index);
                                  handleChange(e);
                                }}
                                onBlur={handleBlur}
                              />
                            </Grid>
                            <Grid className={classes.rsbuttonPrn}>
                              <FormGroup>
                                <FormControlLabel
                                  className={classes.rsPrncheck}
                                  // label="Mark PRN"
                                  label="PRN"
                                  control={
                                    // <>
                                    //   {item?.changeable_prn ? (
                                    //     <Button
                                    //       variant="contained"
                                    //       onClick={(e) => {
                                    //         handleChangeAction(e, index);
                                    //       }}
                                    //     >
                                    //       Mark not PRN
                                    //     </Button>
                                    //   ) : (
                                    //     <Button
                                    //       variant="outlined"
                                    //       onClick={(e) => {
                                    //         handleChangeAction(e, index);
                                    //       }}
                                    //     >
                                    //       Mark PRN
                                    //     </Button>
                                    //   )}
                                    //   <Box>
                                    //     {item?.changeable_prn ? (
                                    //       <Button
                                    //         variant="contained"
                                    //         onClick={(e) => {
                                    //           handleChangeAction(e, index);
                                    //         }}
                                    //       >
                                    //         PRN
                                    //       </Button>
                                    //     ) : (
                                    //       <Button
                                    //         variant="outlined"
                                    //         onClick={(e) => {
                                    //           handleChangeAction(e, index);
                                    //         }}
                                    //       >
                                    //         Mark PRN
                                    //       </Button>
                                    //     )}
                                    //   </Box>
                                    // </>
                                    <Checkbox
                                      color="primary"
                                      checked={
                                        item?.changeable_prn
                                          ? item?.changeable_prn === true
                                          : false
                                      }
                                      onChange={(e, value) => {
                                        handleChangeAction(e, index);
                                      }}
                                    />
                                  }
                                />
                              </FormGroup>
                            </Grid>
                            {/* </Grid> */}
                            <Grid>
                              <HtmlTooltipMain title="Remove Drug">
                                <Box
                                  className={classes.rsMedicationGrudCloseIcon}
                                  onClick={(e) =>
                                    handleClickRemoveDrug(index, item?.id)
                                  }
                                >
                                  <Box>
                                    <PrimaryIcon
                                      width="24px"
                                      height="24px"
                                      icon={DeleteIconLined}
                                      color="white"
                                    />
                                    {/* <Typography>Remove</Typography> */}
                                  </Box>
                                </Box>
                              </HtmlTooltipMain>
                            </Grid>
                          </Grid>
                        </Grid>
                      );
                    })}

                    {/* <Table
                    stickyHeader
                    style={{ marginTop: "20px" }}
                    id="quantity"
                  >


                    
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ width: "100%" }}>
                          <div style={{ display: "flex" }}>
                            DRUG{" "}
                            <div style={{ color: "red", marginLeft: "5px" }}>
                              *
                            </div>{" "}
                          </div>
                        </TableCell>
                        <TableCell style={{ width: "10%" }}>QUANTITY</TableCell>
                        <TableCell style={{ width: "0%", textAlign: "center" }}>
                          <div style={{ display: "flex" }}>
                            {" "}
                            PRN <QuestionMarkIcon width="20px" height="20px" />
                          </div>
                        </TableCell>
                        <TableCell style={{ width: "0%" }}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {medications?.map((item, index) => {
                        return (
                          <TableRow className={classes.tableBody}>
                            <TableCell>
                              <DrugAutoComplete
                                listOpen={listOpen}
                                fullWidth
                                filterMedication={medications}
                                className={classes.rsDrugAutoCompleteBox}
                                value={item}
                                onChange={(e, value) => {
                                  value = value
                                    ? {
                                        ...value,
                                        name: value?.label,
                                      }
                                    : value;
                                  delete value?.label;
                                  handleDrugChange(e, index, value);
                                  handleChange("drug", value);
                                  if (value !== null) {
                                    quantityRef.current.focus();
                                  }
                                }}
                                id={`name_${index}`}
                                patientInfoActionType={patientInfoActionType}
                                excludeDrugs={medicationId}
                                renderInput={(params) => (
                                  <>
                                    <TextField
                                      inputRef={
                                        patientInfoActionType === "patientInfo"
                                          ? medicationRef
                                          : ""
                                      }
                                      id={`name_${index}`}
                                      autoFocus={
                                        patientInfoActionType === "patientInfo"
                                      }
                                      {...params}
                                      label="Drug Name"
                                      placeholder="Choose Drug"
                                      error={
                                        item?.errors?.name && item?.errors?.name
                                      }
                                      helperText={
                                        item?.errors?.name && item?.errors?.name
                                      }
                                      onBlur={handleBlur}
                                    />
                                  </>
                                )}
                              />
                            </TableCell>
                            <TableCell> 
                              <TextField
                                variant="outlined"
                                fullWidth
                                placeholder="00"
                                size="small"
                                // type="number"
                                inputProps={{ maxLength: 50 }}
                                name={`medications[${index}]`}
                                value={item?.quantity}
                                inputRef={quantityRef}
                                error={
                                  item?.errors?.quantity &&
                                  item?.errors?.quantity
                                }
                                helperText={
                                  item?.errors?.quantity &&
                                  item?.errors?.quantity
                                }
                                id={`quantity_${index}`}
                                onChange={(e, value) => {
                                  handleChangeQuantity(e, index);
                                  handleChange(e);
                                }}
                                onBlur={handleBlur}
                                className={classes.rsTextField}
                              />
                            </TableCell>
                            <TableCell className={classes.rsbuttonPrn}>
                              <FormGroup>
                                <FormControlLabel
                                  className={classes.rsPrncheck}
                                  control={
                                    <>
                                      {item?.changeable_prn ? (
                                        <Button
                                          variant="contained"
                                          onClick={(e) => {
                                            handleChangeAction(e, index);
                                          }}
                                        >
                                          Mark not PRN
                                        </Button>
                                      ) : (
                                        <Button
                                          variant="outlined"
                                          onClick={(e) => {
                                            handleChangeAction(e, index);
                                          }}
                                        >
                                          Mark PRN
                                        </Button>
                                      )}
                                      <Box>
                                        {item?.changeable_prn ? (
                                          <Button
                                            variant="contained"
                                            onClick={(e) => {
                                              handleChangeAction(e, index);
                                            }}
                                          >
                                            PRN
                                          </Button>
                                        ) : (
                                          <Button
                                            variant="outlined"
                                            onClick={(e) => {
                                              handleChangeAction(e, index);
                                            }}
                                          >
                                            Mark PRN
                                          </Button>
                                        )}
                                      </Box>
                                    </>
                                    // <Checkbox
                                    //   color="primary"
                                    //   checked={
                                    //     item?.changeable_prn
                                    //       ? item?.changeable_prn === true
                                    //       : false
                                    //   }
                                    //   onChange={(e, value) => {
                                    //     handleChangeAction(e, index);
                                    //   }}
                                    // />
                                  }
                                />
                              </FormGroup>
                            </TableCell>
                            <TableCell>
                              <HtmlTooltipMain title="Close Drug">
                                <Box
                                  className={classes.rsMedicationGrudCloseIcon}
                                  onClick={(e) =>
                                    handleClickRemoveDrug(index, item?.id)
                                  }
                                >
                                  <Box>
                                    <PrimaryIcon
                                      width="20px"
                                      icon={CloseIcon}
                                      color="white"
                                    />
                                  </Box>
                                </Box>
                              </HtmlTooltipMain>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>



                  </Table> */}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
          {width < 1100 && (
            <Grid
              className={
                dialog ? classes.btnContainerDailog : classes.btnContainer
              }
              classes={classes.btnContainerDailog}
            >
              <Box>
                <Button
                  variant="outlined"
                  className={clsx("BtnGray", classes.rsPatientCancelBtn)}
                  onClick={() => {
                    if (typeof callBackOnCancel === "function") {
                      callBackOnCancel();
                    } else {
                      localStorage.setItem('isPatientCancel', 'true');
                      setLocalStorage('isPatientCancel', 'true');
                      navigate("/patients");
                      // let payload = {
                      //   offset: 0,
                      // };
                      // if (
                      //   selectedHeaderPharmacyId !== "" &&
                      //   selectedHeaderPharmacyId !== "all"
                      // ) {
                      //   payload.pharmacy_id = [selectedHeaderPharmacyId];
                      // }
                      // getPatientListAction(payload);
                    }
                  }}
                  // className={classes.rsPatientCancelBtn}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  type="submit"
                  className={classes.rsSubmittBtn}
                  disabled={
                    createPatientData?.loading ||
                    updatePatientData?.loading ||
                    singlePatientData.loading
                  }
                  startIcon={
                    (createPatientData?.loading ||
                      updatePatientData?.loading) && (
                      <CircularProgress color="white" size="20px" />
                    )
                  }
                >
                  Submit
                </Button>
              </Box>
            </Grid>
          )}
        </form>
      )}

      <DrugsDialog
        open={createDrug}
        setOpen={setCreateDrug}
        onAddDrug={handleOnAddDrug}
        editMedication={editMedication}
        medications={medications}
      />
      {/* {isOpenSurgeryModel && ( */}
      <CreateSurgeryDialog
        open={isOpenSurgeryModel}
        setOpen={setIsOpenSurgeryModel}
        surgeryRecordActionType={surgeryRecordActionType}
        resetPatientState={resetPatientState}
        callBackOnSubmitSurgeryInfo={callBackOnSubmitSurgeryInfo}
      />
      <SubscriptionWaringDailog
        open={subscriptionDialog}
        setOpen={setSubscritionDialog}
      />
      <AddPharmacyDialog
        open={addPharmacy}
        pharmacyRecordActionType={"createNewPharmacy"}
        setOpen={setAddPharmacy}
        editData={editPharmacyData}
        setEditData={setEditPharmacyData}
        getList={getList}
        callBackOnSubmitPharmacyInfo={callBackOnSubmitPharmacyInfo}
      />
      <CreateGroupDialog
        open={isOpenGroupModel}
        setOpen={setIsOpenGroupModel}
        editData={editGroupData}
        setEditData={setEditGroupData}
        groupRecordActionType={"createNewGroup"}
        getList={getList}
        getListFlag={true}
        callBackOnSubmitGroupInfo={callBackOnSubmitGroupInfo}
        showAddPatientDropDown={false}
        patientCreate={true}
      />
      <PatientNotesDialog
        open={openNotesDailog}
        setOpen={setOpenNotesDailog}
        title={notesData.title}
        index={notesData.index}
        data={
          notesEdit &&
          typeof notesData.index === "number" &&
          pageAccessMode !== "create"
            ? notesData.data
            : values.notes[notesData.index]
        }
        editState={notesEdit}
        handleChange={handleChange}
        handleNoteChange={handleNoteChange}
        handleClickAddNote={handleClickAddNote}
        setNotesData={setNotesData}
        setNotesArray={setNotesArray}
        error={errors?.notes}
        helperText={errors?.notes}
        touched={touched}
        pageAccessMode={pageAccessMode}
        setErrors={setErrors}
      />
      <PatientCreateTag
        open={openTagDialog}
        setOpen={setOpenTagDialog}
        handleChange={handleChange}
        tags={tags}
        setTags={setTags}
        titleValues={values?.tags_title}
        titleError={touched?.tags_title && errors?.tags_title}
        titleHelperText={touched?.tags_title && errors?.tags_title}
        colorValues={values?.g_color_code}
        colorError={errors?.g_color_code}
        colorHelperText={errors?.g_color_code}
        handleClickAway={handleClickAway}
        showColorPalette={showColorPalette}
        setShowColorPalette={setShowColorPalette}
        setFieldValue={setFieldValue}
        handleColourTagAdd={handleColourTagAdd}
        handleColourTagRemove={handleColourTagRemove}
        handleBlur={handleBlur}
      />
      {/* )} */}
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        title="Are you sure?"
        body=" You won't be able to undo this Action ! "
        handleSubmit={() => handleClickRemoveNote(removeIndex)}
        actionBtnTitle=" Yes Delete It ! "
        // loading={deleteRepeatOrder?.loading}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  createPatientData: state.patient.createPatientData,
  durgFieldList: state.patient.durgFieldList,
  updatePatientData: state.patient.updatePatientData,
  singlePatientData: state.patient.singlePatientData,
});
const mapDispatchToProps = (dispatch) => ({
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  createPatientAction: (payload) =>
    dispatch({ type: START_CREATE_PATIENT, payload }),
  updatePatientAction: (id, payload) =>
    dispatch({ type: START_UPDATE_PATIENT, id, payload }),
  getSinglePatientAction: (id) =>
    dispatch({ type: START_GET_SINGLE_PATIENT, id }),
  resetPatientState: (key, payload) =>
    dispatch({ type: RESET_PATIENT_STATE, key, payload }),
  getPharmacyListAction: (payload) =>
    dispatch({ type: START_PHARMACY_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getOrderListAction: (payload) =>
    dispatch({ type: START_GET_REPEAT_ORDER_LIST, payload }),
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  getPharmaciesListAction: (payload) =>
    dispatch({ type: START_GET_PHARMACIES_LIST, payload }),
  getSGroupListAction: (payload) =>
    dispatch({ type: START_GET_GROUP_LIST, payload }),
  getOrderCountTypeAction: (payload) =>
    dispatch({ type: START_ORDER_COUNT_TYPE, payload }),
  getDrugFieldListAction: (payload) =>
    dispatch({ type: START_DRUG_LIST, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientsCreateAndEdit);
